import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "migration-console pb-5" }
const _hoisted_2 = { class: "fw-bold fs-5" }
const _hoisted_3 = { class: "small" }
const _hoisted_4 = { class: "ms-auto text-end" }
const _hoisted_5 = {
  key: 0,
  class: "badge fs-6 bg-secondary"
}
const _hoisted_6 = {
  key: 2,
  class: "small mt-1"
}
const _hoisted_7 = {
  key: 3,
  class: "small mt-1"
}
const _hoisted_8 = {
  key: 4,
  class: "small mt-1"
}
const _hoisted_9 = { class: "card mb-3" }
const _hoisted_10 = {
  key: 0,
  class: "card-body py-2 d-flex align-items-center gap-2 flex-wrap"
}
const _hoisted_11 = { class: "fs-6 user-select-all" }
const _hoisted_12 = {
  key: 0,
  class: "badge bg-success",
  title: "BD de escritura del run (writeDbId). El apply/reset de este run escribe aquí."
}
const _hoisted_13 = {
  key: 1,
  class: "badge bg-danger",
  title: "Este run NO tiene writeDbId: escribe en (default), que en Topología A es la red de rollback."
}
const _hoisted_14 = { class: "small text-muted" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 1,
  class: "card-body py-2"
}
const _hoisted_18 = { class: "d-flex align-items-center gap-2 mb-2" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "run-grid mb-3"
}
const _hoisted_21 = ["disabled", "onClick"]
const _hoisted_22 = { class: "run-card-top" }
const _hoisted_23 = { class: "run-card-id" }
const _hoisted_24 = { class: "run-card-sub" }
const _hoisted_25 = { class: "text-muted" }
const _hoisted_26 = { class: "run-card-db" }
const _hoisted_27 = {
  key: 0,
  class: "badge bg-success"
}
const _hoisted_28 = {
  key: 1,
  class: "badge bg-danger"
}
const _hoisted_29 = {
  key: 1,
  class: "text-muted small mb-3"
}
const _hoisted_30 = { class: "d-flex align-items-center gap-2 flex-wrap" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 2,
  class: "alert alert-danger py-2 small mt-2 mb-0"
}
const _hoisted_33 = { class: "d-flex gap-2 mt-2" }
const _hoisted_34 = { class: "form-check d-flex align-items-center ms-2" }
const _hoisted_35 = {
  key: 3,
  class: "alert alert-success py-2 small mt-2 mb-0"
}
const _hoisted_36 = {
  key: 2,
  class: "card-body border-top py-2"
}
const _hoisted_37 = { class: "d-flex align-items-center gap-2 flex-wrap" }
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "d-flex align-items-center gap-2 flex-wrap mt-1" }
const _hoisted_40 = { class: "user-select-all" }
const _hoisted_41 = {
  key: 0,
  class: "alert alert-warning py-2 small mt-2 mb-0"
}
const _hoisted_42 = {
  key: 1,
  class: "alert alert-danger d-flex align-items-center gap-2 py-2 mt-2 mb-0 prod-strip"
}
const _hoisted_43 = {
  key: 2,
  class: "alert alert-warning py-2 small mt-2 mb-0"
}
const _hoisted_44 = {
  key: 3,
  class: "card-body border-top py-2"
}
const _hoisted_45 = { class: "d-flex align-items-center gap-2 flex-wrap" }
const _hoisted_46 = { class: "user-select-all" }
const _hoisted_47 = {
  key: 4,
  class: "card-body border-top py-2"
}
const _hoisted_48 = { class: "d-flex align-items-center gap-2 flex-wrap" }
const _hoisted_49 = {
  key: 0,
  class: "badge bg-success"
}
const _hoisted_50 = {
  key: 0,
  class: "small text-muted mt-1"
}
const _hoisted_51 = { class: "user-select-all" }
const _hoisted_52 = {
  key: 1,
  class: "alert alert-danger py-2 small mt-2 mb-0"
}
const _hoisted_53 = {
  key: 2,
  class: "small text-muted mt-1"
}
const _hoisted_54 = {
  key: 0,
  class: "alert alert-danger py-2"
}
const _hoisted_55 = {
  key: 1,
  class: "alert alert-danger py-2"
}
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { class: "error-text" }
const _hoisted_59 = {
  key: 2,
  class: "alert alert-info"
}
const _hoisted_60 = {
  key: 3,
  class: "steps"
}
const _hoisted_61 = ["aria-expanded", "onClick", "onKeydown"]
const _hoisted_62 = { class: "d-flex align-items-start gap-2 step-headline" }
const _hoisted_63 = { class: "step-title" }
const _hoisted_64 = { class: "d-flex align-items-center gap-2 step-headline-badges" }
const _hoisted_65 = { class: "badge bg-light text-dark border" }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { class: "d-flex align-items-center gap-2 flex-wrap justify-content-between step-subline" }
const _hoisted_68 = {
  class: "step-key",
  title: 'id estable del paso'
}
const _hoisted_69 = { class: "d-flex align-items-center gap-2 flex-wrap justify-content-end step-subline-meta" }
const _hoisted_70 = {
  key: 0,
  class: "badge bg-light text-dark border",
  title: "Sólo mira: este paso no escribe nada",
  "aria-label": "Sólo mira: este paso no escribe nada"
}
const _hoisted_71 = ["title", "aria-label"]
const _hoisted_72 = { key: 0 }
const _hoisted_73 = ["title", "aria-label"]
const _hoisted_74 = ["title"]
const _hoisted_75 = {
  key: 3,
  class: "badge bg-secondary",
  title: "cuánto tardó"
}
const _hoisted_76 = { class: "card-body" }
const _hoisted_77 = ["innerHTML"]
const _hoisted_78 = {
  key: 0,
  class: "alert alert-warning py-2 small step-prose"
}
const _hoisted_79 = ["innerHTML"]
const _hoisted_80 = {
  key: 1,
  class: "alert alert-secondary py-2 small"
}
const _hoisted_81 = { class: "fw-bold" }
const _hoisted_82 = { class: "text-muted fw-normal" }
const _hoisted_83 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_84 = { class: "mt-1" }
const _hoisted_85 = {
  key: 2,
  class: "alert alert-secondary py-2 small mb-2"
}
const _hoisted_86 = {
  key: 3,
  class: "mb-3"
}
const _hoisted_87 = { class: "row g-3" }
const _hoisted_88 = { class: "col-md-6" }
const _hoisted_89 = { class: "col-md-6" }
const _hoisted_90 = {
  key: 0,
  class: "text-danger small mt-1"
}
const _hoisted_91 = { class: "mb-3" }
const _hoisted_92 = { class: "small mb-1" }
const _hoisted_93 = ["placeholder"]
const _hoisted_94 = {
  key: 0,
  class: "text-danger small mt-1"
}
const _hoisted_95 = {
  key: 1,
  class: "text-danger small mt-1"
}
const _hoisted_96 = {
  key: 2,
  class: "text-success small mt-1"
}
const _hoisted_97 = {
  key: 3,
  class: "text-danger small mt-1"
}
const _hoisted_98 = { class: "mb-3" }
const _hoisted_99 = ["placeholder"]
const _hoisted_100 = {
  key: 0,
  class: "text-danger small mt-1"
}
const _hoisted_101 = {
  key: 1,
  class: "text-success small mt-1"
}
const _hoisted_102 = {
  key: 5,
  class: "mb-3"
}
const _hoisted_103 = { class: "d-flex align-items-center gap-2 flex-wrap mb-2" }
const _hoisted_104 = { class: "small fw-bold" }
const _hoisted_105 = { class: "nav nav-tabs small ext-tabs" }
const _hoisted_106 = ["onClick"]
const _hoisted_107 = {
  key: 0,
  class: "border border-top-0 rounded-bottom p-2"
}
const _hoisted_108 = { class: "d-flex align-items-center gap-2 flex-wrap mb-2" }
const _hoisted_109 = ["title", "onClick"]
const _hoisted_110 = { class: "user-select-all" }
const _hoisted_111 = {
  key: 0,
  class: "fas fa-ban me-1"
}
const _hoisted_112 = ["title", "onClick"]
const _hoisted_113 = {
  key: 0,
  class: "ext-card"
}
const _hoisted_114 = {
  key: 0,
  class: "alert alert-secondary py-2 px-2 small mb-2"
}
const _hoisted_115 = {
  key: 1,
  class: "table table-sm table-striped small mb-0 ext-params"
}
const _hoisted_116 = { class: "ext-label" }
const _hoisted_117 = {
  key: 0,
  class: "badge bg-danger ms-1",
  title: "NO se puede cambiar después de instalar. Si sale mal, hay que DESINSTALAR la instancia y volver a crearla."
}
const _hoisted_118 = { class: "ext-value" }
const _hoisted_119 = { class: "ext-copy-slot" }
const _hoisted_120 = ["title", "onClick"]
const _hoisted_121 = {
  key: 0,
  class: "user-select-all"
}
const _hoisted_122 = {
  key: 1,
  class: "text-muted fst-italic"
}
const _hoisted_123 = {
  key: 6,
  class: "mb-3"
}
const _hoisted_124 = ["disabled"]
const _hoisted_125 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_126 = {
  key: 1,
  class: "fas fa-file-invoice-dollar"
}
const _hoisted_127 = { class: "small text-muted ms-2" }
const _hoisted_128 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_129 = { class: "d-flex align-items-center gap-2 flex-wrap mb-2" }
const _hoisted_130 = ["disabled"]
const _hoisted_131 = { class: "small text-muted" }
const _hoisted_132 = { class: "alert alert-info py-2 small mb-2" }
const _hoisted_133 = {
  key: 0,
  class: "alert alert-warning py-2 small mb-2"
}
const _hoisted_134 = {
  key: 1,
  class: "alert alert-secondary py-2 small mb-2"
}
const _hoisted_135 = { class: "table-responsive" }
const _hoisted_136 = { class: "table table-sm small mb-2 points-report-table" }
const _hoisted_137 = {
  rowspan: "2",
  class: "pr-acct"
}
const _hoisted_138 = {
  key: 0,
  class: "badge bg-secondary ms-1",
  title: "colocado, pero sin documento en legacy-2026: los ceros son reales"
}
const _hoisted_139 = {
  rowspan: "2",
  class: "text-center pr-side-cell"
}
const _hoisted_140 = ["title"]
const _hoisted_141 = {
  key: 0,
  class: "pr-swap ms-1",
  title: "CAMBIÓ DE PIERNA: en el árbol nuevo cuelga de una pierna de su padre distinta de la que tenía en el viejo."
}
const _hoisted_142 = {
  rowspan: "2",
  class: "text-center pr-num"
}
const _hoisted_143 = {
  rowspan: "2",
  class: "text-center pr-num"
}
const _hoisted_144 = {
  rowspan: "2",
  class: "text-center pr-side-cell pr-sep pr-viejo"
}
const _hoisted_145 = ["title"]
const _hoisted_146 = {
  rowspan: "2",
  class: "text-center pr-num pr-viejo"
}
const _hoisted_147 = {
  rowspan: "2",
  class: "text-center pr-num pr-viejo"
}
const _hoisted_148 = { class: "text-center pr-num pr-sep pr-leg-a pr-cuadre-cell" }
const _hoisted_149 = ["title", "aria-label", "onClick", "onKeydown"]
const _hoisted_150 = { class: "text-center pr-num pr-nuevo-edge pr-leg-a pr-cuadre-cell" }
const _hoisted_151 = ["title", "aria-label", "onClick", "onKeydown"]
const _hoisted_152 = { rowspan: "2" }
const _hoisted_153 = {
  key: 0,
  class: "badge bg-secondary",
  title: "El reporte está confirmado: para volver a tocar, pulsa «Cancelar» arriba."
}
const _hoisted_154 = ["title"]
const _hoisted_155 = {
  key: 2,
  class: "pr-acciones"
}
const _hoisted_156 = { class: "pr-acciones-fila" }
const _hoisted_157 = ["disabled", "title", "onClick"]
const _hoisted_158 = ["disabled", "title", "onClick"]
const _hoisted_159 = ["title"]
const _hoisted_160 = {
  key: 2,
  class: "badge pr-badge-falso",
  title: "Marcada como aplicada sin haber copiado nada. Bórrala para poder reintentarla."
}
const _hoisted_161 = {
  key: 0,
  class: "badge bg-danger",
  title: "La huella del árbol no coincide con la de cuando se aplicó: alguien rehizo los árboles. Borra y vuelve a aplicar."
}
const _hoisted_162 = {
  key: 1,
  class: "badge pr-badge-ojo",
  title: "La copia se cortó a la mitad: hay documentos escritos y no se sabe cuántos. La bitácora guarda la lista completa de ids, así que «Borrar» los limpia todos. Bórralo y vuelve a aplicar."
}
const _hoisted_163 = ["title"]
const _hoisted_164 = { class: "pr-crear-cab" }
const _hoisted_165 = { class: "pr-crear-et" }
const _hoisted_166 = {
  key: 0,
  class: "pr-fuente pr-fuente-nota",
  title: "Pierna infinita: su saldo no se ganó, se OTORGA. Por eso la caja nace con la concesión y no con los dos números de al lado."
}
const _hoisted_167 = { class: "pr-crear-linea" }
const _hoisted_168 = ["value", "aria-label", "onInput"]
const _hoisted_169 = ["disabled", "title", "onClick"]
const _hoisted_170 = {
  key: 0,
  class: "pr-revisar"
}
const _hoisted_171 = { class: "text-center pr-num pr-sep pr-cuadre-cell" }
const _hoisted_172 = ["title", "aria-label", "onClick", "onKeydown"]
const _hoisted_173 = { class: "text-center pr-num pr-nuevo-edge pr-cuadre-cell" }
const _hoisted_174 = ["title", "aria-label", "onClick", "onKeydown"]
const _hoisted_175 = {
  key: 2,
  class: "small text-muted"
}
const _hoisted_176 = { class: "d-flex align-items-center gap-2 flex-wrap" }
const _hoisted_177 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_178 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_179 = {
  key: 4,
  class: "border rounded p-2 mb-2"
}
const _hoisted_180 = {
  key: 0,
  class: "form-check small mb-2"
}
const _hoisted_181 = {
  class: "form-check-label",
  for: "ackCuadreViejo"
}
const _hoisted_182 = ["disabled", "title"]
const _hoisted_183 = {
  key: 1,
  class: "small text-danger ms-2"
}
const _hoisted_184 = {
  key: 2,
  class: "small text-muted ms-2"
}
const _hoisted_185 = {
  key: 5,
  class: "alert alert-success py-2 small mb-2 d-flex align-items-center gap-2 flex-wrap"
}
const _hoisted_186 = { class: "flex-grow-1" }
const _hoisted_187 = ["disabled"]
const _hoisted_188 = { class: "pr-cuadre-caja" }
const _hoisted_189 = { class: "d-flex align-items-center gap-2 mb-2 border-bottom pb-2" }
const _hoisted_190 = { class: "flex-grow-1" }
const _hoisted_191 = { class: "small mb-1" }
const _hoisted_192 = { class: "table table-sm small mb-1 w-auto" }
const _hoisted_193 = { class: "table-danger" }
const _hoisted_194 = { class: "text-end pe-3" }
const _hoisted_195 = { class: "text-end pe-3" }
const _hoisted_196 = { class: "text-end pe-3" }
const _hoisted_197 = { class: "text-end pe-3" }
const _hoisted_198 = { class: "text-end pe-3" }
const _hoisted_199 = { class: "text-end pe-3" }
const _hoisted_200 = { class: "small text-muted" }
const _hoisted_201 = { key: 0 }
const _hoisted_202 = { key: 2 }
const _hoisted_203 = { key: 3 }
const _hoisted_204 = { key: 4 }
const _hoisted_205 = {
  key: 7,
  class: "mb-3"
}
const _hoisted_206 = ["disabled"]
const _hoisted_207 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_208 = {
  key: 1,
  class: "fas fa-list-check"
}
const _hoisted_209 = { class: "small text-muted ms-2" }
const _hoisted_210 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_211 = {
  key: 8,
  class: "mb-3"
}
const _hoisted_212 = { class: "d-flex align-items-center gap-2 flex-wrap" }
const _hoisted_213 = ["disabled"]
const _hoisted_214 = ["disabled", "title"]
const _hoisted_215 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_216 = {
  key: 1,
  class: "fas fa-play"
}
const _hoisted_217 = { class: "small text-muted mt-1" }
const _hoisted_218 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_219 = {
  key: 9,
  class: "d-flex justify-content-end gap-2"
}
const _hoisted_220 = ["disabled", "onClick"]
const _hoisted_221 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_222 = {
  key: 1,
  class: "fas fa-forward"
}
const _hoisted_223 = ["disabled", "onClick"]
const _hoisted_224 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_225 = {
  key: 1,
  class: "fas fa-check"
}
const _hoisted_226 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_227 = { class: "d-flex align-items-center gap-2 flex-wrap mb-1" }
const _hoisted_228 = ["disabled", "title", "onClick"]
const _hoisted_229 = {
  key: 0,
  class: "alert alert-danger py-2 small mb-2"
}
const _hoisted_230 = {
  key: 1,
  class: "small text-muted mb-1"
}
const _hoisted_231 = {
  key: 2,
  class: "alert alert-danger py-2 small mb-2"
}
const _hoisted_232 = {
  key: 0,
  class: "cmd-note"
}
const _hoisted_233 = {
  key: 1,
  class: "cmd-row"
}
const _hoisted_234 = ["disabled", "title", "onClick"]
const _hoisted_235 = {
  key: 2,
  class: "cmd-note cmd-note-after"
}
const _hoisted_236 = {
  key: 5,
  class: "small text-danger mt-1"
}
const _hoisted_237 = { class: "row g-2 align-items-end" }
const _hoisted_238 = {
  key: 0,
  class: "col-12"
}
const _hoisted_239 = { class: "d-flex align-items-center gap-2 flex-wrap" }
const _hoisted_240 = {
  key: 0,
  class: "badge bg-success"
}
const _hoisted_241 = {
  key: 0,
  class: "small text-muted mt-1"
}
const _hoisted_242 = { class: "user-select-all" }
const _hoisted_243 = {
  key: 1,
  class: "alert alert-danger py-2 small mt-2 mb-0"
}
const _hoisted_244 = { class: "col-auto" }
const _hoisted_245 = ["onUpdate:modelValue"]
const _hoisted_246 = { class: "col" }
const _hoisted_247 = ["onUpdate:modelValue"]
const _hoisted_248 = { class: "col-auto" }
const _hoisted_249 = ["disabled", "onClick"]
const _hoisted_250 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_251 = {
  key: 1,
  class: "fas fa-forward"
}
const _hoisted_252 = { class: "col-auto" }
const _hoisted_253 = ["disabled", "title", "onClick"]
const _hoisted_254 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_255 = {
  key: 1,
  class: "fas fa-check"
}
const _hoisted_256 = { class: "d-flex gap-2 mb-1 flex-wrap" }
const _hoisted_257 = ["disabled", "onClick"]
const _hoisted_258 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_259 = {
  key: 1,
  class: "fas fa-calculator"
}
const _hoisted_260 = ["disabled", "onClick"]
const _hoisted_261 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_262 = {
  key: 1,
  class: "fas fa-eye"
}
const _hoisted_263 = ["disabled", "onClick"]
const _hoisted_264 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_265 = {
  key: 1,
  class: "fas fa-play"
}
const _hoisted_266 = { class: "form-check ms-2 d-flex align-items-center" }
const _hoisted_267 = ["id", "onUpdate:modelValue", "disabled"]
const _hoisted_268 = ["for"]
const _hoisted_269 = {
  key: 0,
  class: "small text-danger mb-3"
}
const _hoisted_270 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_271 = {
  key: 14,
  class: "alert alert-danger py-2 small mt-3"
}
const _hoisted_272 = ["disabled", "onClick"]
const _hoisted_273 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_274 = {
  key: 1,
  class: "fas fa-unlock"
}
const _hoisted_275 = {
  key: 15,
  class: "alert alert-warning py-2 small mt-3"
}
const _hoisted_276 = {
  key: 16,
  class: "mt-3"
}
const _hoisted_277 = { class: "small mb-0" }
const _hoisted_278 = {
  key: 17,
  class: "alert alert-danger py-2 mt-3"
}
const _hoisted_279 = { class: "fw-bold mb-1" }
const _hoisted_280 = { class: "error-text small" }
const _hoisted_281 = {
  key: 18,
  class: "mt-3"
}
const _hoisted_282 = { class: "result-block" }
const _hoisted_283 = {
  key: 19,
  class: "mt-3"
}
const _hoisted_284 = { class: "result-block" }
const _hoisted_285 = {
  key: 20,
  class: "small text-danger mt-2"
}
const _hoisted_286 = { class: "d-flex justify-content-center mt-3" }
const _hoisted_287 = ["title", "aria-label", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CatalogCheck = _resolveComponent("CatalogCheck")!
  const _component_CofounderRanks = _resolveComponent("CofounderRanks")!
  const _component_StepAuto = _resolveComponent("StepAuto")!
  const _component_DraftPreviewTable = _resolveComponent("DraftPreviewTable")!
  const _component_MmiDraftPreview = _resolveComponent("MmiDraftPreview")!
  const _component_InvariantGate = _resolveComponent("InvariantGate")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["env-banner d-flex align-items-center gap-3 p-3 mb-3 rounded", _ctx.isProd ? 'env-prod' : 'env-sandbox'])
    }, [
      _createElementVNode("i", {
        class: _normalizeClass(["fas fa-2x", _ctx.isProd ? 'fa-radiation' : 'fa-flask'])
      }, null, 2),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.isProd ? "PRODUCCIÓN" : "SANDBOX") + " — ", 1),
          _createElementVNode("code", null, _toDisplayString(_ctx.environment), 1)
        ]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.isProd
              ? "Esto es real. Cada paso mueve la red de verdad."
              : "Entorno de ensayo. Aquí se practica la migración y la herramienta."), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.freeze === null)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [...(_cache[28] || (_cache[28] = [
              _createElementVNode("i", { class: "fas fa-hourglass-half" }, null, -1),
              _createTextVNode(" COMPROBANDO EL FREEZE ", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass(["badge fs-6", _ctx.freeze.frozen ? 'bg-dark' : 'bg-danger'])
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["fas", _ctx.freeze.frozen ? 'fa-snowflake' : 'fa-lock-open'])
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(_ctx.freeze.frozen ? "SISTEMA CONGELADO" : "SISTEMA ABIERTO"), 1)
            ], 2)),
        (_ctx.freeze === null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, " sin respuesta todavía — no es un veredicto "))
          : (_ctx.freeze.frozen && _ctx.run?.frozenBy)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "por " + _toDisplayString(_ctx.run.frozenBy), 1))
            : (!_ctx.freeze.frozen)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, " offline no es true en la BD que sirven las functions "))
              : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.run)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _cache[33] || (_cache[33] = _createElementVNode("span", { class: "fw-bold" }, "Run", -1)),
            _createElementVNode("code", _hoisted_11, _toDisplayString(_ctx.runId), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["badge", _ctx.runStatusClass(_ctx.run.status)])
            }, _toDisplayString(_ctx.run.status), 3),
            (_ctx.run.writeDbId)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                  _cache[29] || (_cache[29] = _createElementVNode("i", { class: "fas fa-database" }, null, -1)),
                  _createTextVNode(" escribe en " + _toDisplayString(_ctx.run.writeDbId), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_13, [...(_cache[30] || (_cache[30] = [
                  _createElementVNode("i", { class: "fas fa-triangle-exclamation" }, null, -1),
                  _createTextVNode(" escribe en (default) — RED DE ROLLBACK ", -1)
                ]))])),
            _createElementVNode("span", _hoisted_14, [
              _createTextVNode(_toDisplayString(_ctx.doneCount) + "/" + _toDisplayString(_ctx.steps.length) + " pasos · por ", 1),
              _createElementVNode("strong", null, _toDisplayString(_ctx.run.createdBy), 1)
            ]),
            _createElementVNode("button", {
              class: "btn btn-sm btn-outline-secondary ms-auto",
              disabled: _ctx.busy,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)))
            }, [...(_cache[31] || (_cache[31] = [
              _createElementVNode("i", { class: "fas fa-rotate" }, null, -1),
              _createTextVNode(" Recargar ", -1)
            ]))], 8, _hoisted_15),
            _createElementVNode("button", {
              class: "btn btn-sm btn-outline-dark",
              disabled: _ctx.busy,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeRun && _ctx.closeRun(...args))),
              title: "Volver a elegir otro run"
            }, [...(_cache[32] || (_cache[32] = [
              _createElementVNode("i", { class: "fas fa-xmark" }, null, -1),
              _createTextVNode(" Cerrar ", -1)
            ]))], 8, _hoisted_16)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _cache[35] || (_cache[35] = _createElementVNode("span", { class: "fw-bold" }, "Elige un run", -1)),
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-secondary ms-auto",
                disabled: _ctx.busy,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.loadRuns && _ctx.loadRuns(...args)))
              }, [...(_cache[34] || (_cache[34] = [
                _createElementVNode("i", { class: "fas fa-rotate" }, null, -1),
                _createTextVNode(" Recargar lista ", -1)
              ]))], 8, _hoisted_19)
            ]),
            (_ctx.runsList.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.runsList, (r) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: r.runId,
                      type: "button",
                      class: "run-card",
                      disabled: _ctx.busy,
                      onClick: ($event: any) => (_ctx.selectRun(r.runId))
                    }, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("span", _hoisted_23, _toDisplayString(r.runId), 1),
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", _ctx.runStatusClass(r.status)])
                        }, _toDisplayString(r.status), 3)
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.runDoneCount(r)) + " pasos hechos", 1),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(r.environment), 1)
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        (r.writeDbId)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                              _cache[36] || (_cache[36] = _createElementVNode("i", { class: "fas fa-database" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(r.writeDbId), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_28, [...(_cache[37] || (_cache[37] = [
                              _createElementVNode("i", { class: "fas fa-triangle-exclamation" }, null, -1),
                              _createTextVNode(" (default) ", -1)
                            ]))]))
                      ])
                    ], 8, _hoisted_21))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_29, " No hay runs todavía. Crea uno abajo. ")),
            _createElementVNode("div", _hoisted_30, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.runId) = $event)),
                class: "form-control form-control-sm w-auto",
                placeholder: "nombre del run nuevo (ej. ensayo-2026-07-22)",
                onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.runId && _ctx.canCreate && _ctx.openRun()), ["enter"]))
              }, null, 544), [
                [_vModelText, _ctx.runId]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.writeDbId) = $event)),
                class: "form-control form-control-sm w-auto",
                style: {"min-width":"20rem"},
                placeholder: "BD de escritura — gtr-2026",
                title: "BD de escritura del run (#595). En Topología A es gtr-2026, el MISMO nombre en el go-live y en el ensayo. Se fija al crear el run y NO se puede cambiar después."
              }, null, 512), [
                [_vModelText, _ctx.writeDbId]
              ]),
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-primary",
                disabled: _ctx.busy || !_ctx.runId || !_ctx.canCreate,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openRun()))
              }, [...(_cache[38] || (_cache[38] = [
                _createElementVNode("i", { class: "fas fa-plus" }, null, -1),
                _createTextVNode(" Crear / abrir ", -1)
              ]))], 8, _hoisted_31)
            ]),
            (_ctx.targetsDefaultDb)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _cache[41] || (_cache[41] = _createStaticVNode("<strong data-v-35c969b8><i class=\"fas fa-triangle-exclamation\" data-v-35c969b8></i> Sin BD de escritura este run apunta a <code data-v-35c969b8>(default)</code>. </strong><div class=\"mt-1\" data-v-35c969b8> En Topología A <code data-v-35c969b8>(default)</code> es la <strong data-v-35c969b8>red de rollback</strong>: queda congelada e intacta, y el paso 10 lo dice con todas las letras — apuntar ahí <strong data-v-35c969b8>MUTA los 41.6k users</strong> de la red a la que se vuelve si algo sale mal. Lo que va aquí es <code data-v-35c969b8>gtr-2026</code>, el mismo nombre en el go-live y en el ensayo. </div>", 2)),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-outline-danger",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.writeDbId = 'gtr-2026'))
                    }, [...(_cache[39] || (_cache[39] = [
                      _createTextVNode(" Poner ", -1),
                      _createElementVNode("code", { class: "ms-1" }, "gtr-2026", -1)
                    ]))]),
                    _createElementVNode("div", _hoisted_34, [
                      _withDirectives(_createElementVNode("input", {
                        id: "ack-default-db",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ackDefaultDb) = $event)),
                        class: "form-check-input mt-0 me-2",
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.ackDefaultDb]
                      ]),
                      _cache[40] || (_cache[40] = _createElementVNode("label", {
                        class: "form-check-label",
                        for: "ack-default-db"
                      }, [
                        _createTextVNode(" Sé lo que hago: quiero un run sobre "),
                        _createElementVNode("code", null, "(default)")
                      ], -1))
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _cache[42] || (_cache[42] = _createElementVNode("i", { class: "fas fa-database" }, null, -1)),
                  _cache[43] || (_cache[43] = _createTextVNode(" Este run se sellará escribiendo en ", -1)),
                  _createElementVNode("code", null, _toDisplayString(_ctx.writeDbId.trim()), 1),
                  _cache[44] || (_cache[44] = _createTextVNode(". ", -1)),
                  _cache[45] || (_cache[45] = _createElementVNode("strong", null, "No se puede cambiar después", -1)),
                  _cache[46] || (_cache[46] = _createTextVNode(": para otra BD, otro runId. ", -1))
                ]))
          ])),
      (_ctx.run)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _cache[47] || (_cache[47] = _createElementVNode("span", { class: "small fw-bold" }, "Proyecto de los comandos", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.projectId) = $event)),
                class: _normalizeClass(["form-select form-select-sm w-auto project-select", { 'project-select-prod': _ctx.projectIsProd }]),
                title: "Sustituye <PROJECT> en los comandos de TODOS los pasos manuales. Es del run entero, no de un paso. Sólo afecta a lo que se pinta y se copia."
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectOptions, (p) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: p.id,
                    value: p.id
                  }, _toDisplayString(p.label), 9, _hoisted_38))
                }), 128))
              ], 2), [
                [_vModelSelect, _ctx.projectId]
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(["badge fs-6", _ctx.projectIsProd ? 'bg-danger' : 'bg-info text-dark'])
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["fas", _ctx.projectIsProd ? 'fa-radiation' : 'fa-flask'])
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(_ctx.projectIsProd ? "PRODUCCIÓN" : "ensayo"), 1)
              ], 2),
              _cache[48] || (_cache[48] = _createElementVNode("span", { class: "small text-muted" }, [
                _createTextVNode(" sustituye "),
                _createElementVNode("code", null, "<PROJECT>"),
                _createTextVNode(" en los comandos, listo para copiar. Lo que ves es exactamente lo que se copia. ")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_39, [
              _cache[49] || (_cache[49] = _createElementVNode("span", { class: "small text-muted" }, [
                _createElementVNode("i", { class: "fas fa-bucket" }),
                _createTextVNode(),
                _createElementVNode("code", null, "<BUCKET>"),
                _createTextVNode(" = ")
              ], -1)),
              _createElementVNode("code", _hoisted_40, _toDisplayString(_ctx.projectBucket), 1),
              _cache[50] || (_cache[50] = _createElementVNode("span", { class: "small text-muted" }, " el bucket de backups de este proyecto. Ya va puesto en el export y en los dos imports. ", -1))
            ]),
            (_ctx.projectIsProd)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _cache[51] || (_cache[51] = _createElementVNode("i", { class: "fas fa-triangle-exclamation" }, null, -1)),
                  _cache[52] || (_cache[52] = _createTextVNode(" En producción hay ", -1)),
                  _cache[53] || (_cache[53] = _createElementVNode("strong", null, "otro bucket con nombre parecido", -1)),
                  _cache[54] || (_cache[54] = _createTextVNode(", ", -1)),
                  _createElementVNode("code", null, _toDisplayString(_ctx.lookalikeProdBucket), 1),
                  _cache[55] || (_cache[55] = _createTextVNode(", y lo más reciente que guarda es ", -1)),
                  _cache[56] || (_cache[56] = _createElementVNode("strong", null, "de 2022", -1)),
                  _cache[57] || (_cache[57] = _createTextVNode(". No es éste. Si acabas apuntando un import allí no falla nada: el LRO termina en verde y la red se reconstruye sobre datos de hace cuatro años. Por eso el nombre lo pone la consola — no lo teclees. ", -1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.projectIsProd)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [...(_cache[58] || (_cache[58] = [
                  _createElementVNode("i", { class: "fas fa-radiation fa-2x" }, null, -1),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "fw-bold" }, [
                      _createTextVNode(" LOS COMANDOS APUNTAN A "),
                      _createElementVNode("code", null, "gtr-academy"),
                      _createTextVNode(" — PRODUCCIÓN REAL ")
                    ]),
                    _createElementVNode("div", { class: "small" }, [
                      _createTextVNode(" Todo lo que copies de aquí abajo se ejecuta sobre la red viva: backups, borrados y despliegues incluidos. Si esto es un ensayo, vuelve a "),
                      _createElementVNode("code", null, "gtr-sandbox"),
                      _createTextVNode(" AHORA. ")
                    ])
                  ], -1)
                ]))]))
              : _createCommentVNode("", true),
            (_ctx.projectMismatch)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _cache[59] || (_cache[59] = _createElementVNode("i", { class: "fas fa-triangle-exclamation" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.projectMismatch), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.run)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _cache[61] || (_cache[61] = _createElementVNode("span", { class: "small fw-bold" }, "Fecha de migración", -1)),
              _createElementVNode("code", _hoisted_46, _toDisplayString(_ctx.migrationDateIso), 1),
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-secondary py-0",
                title: "Copiar",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.copyMigrationDate && _ctx.copyMigrationDate(...args)))
              }, [
                _cache[60] || (_cache[60] = _createElementVNode("i", { class: "fas fa-copy" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.copiedKey === "migration-date" ? "copiada" : "copiar"), 1)
              ]),
              _cache[62] || (_cache[62] = _createElementVNode("span", { class: "small text-muted" }, [
                _createTextVNode(" el instante del run. Va tal cual en el "),
                _createElementVNode("code", null, "--migration-date"),
                _createTextVNode(" del paso 10; el paso 18 la compara al milisegundo. ")
              ], -1))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.run)
        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _cache[64] || (_cache[64] = _createElementVNode("span", { class: "small fw-bold" }, "Sello del export", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.exportStamp) = $event)),
                class: _normalizeClass(["form-control form-control-sm export-stamp-input", {
              'is-invalid': !!_ctx.exportStampProblem,
              'is-valid': !!_ctx.exportStampValue,
            }]),
                placeholder: "pega aquí la ruta o el sello",
                title: "Lo que devolvió el export del paso del backup. Vale la ruta entera (gs://…/pre-reset-AAAAMMDD-HHMM) o sólo el sello: de la ruta se saca solo. La consola NO lo inventa — el export pudo correrse hace veinte minutos."
              }, null, 2), [
                [_vModelText, _ctx.exportStamp]
              ]),
              (_ctx.exportStampValue)
                ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                    _cache[63] || (_cache[63] = _createElementVNode("i", { class: "fas fa-check" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.exportStampValue), 1)
                  ]))
                : _createCommentVNode("", true),
              _cache[65] || (_cache[65] = _createElementVNode("span", { class: "small text-muted" }, " lo que devolvió el export del backup. Rellena la ruta de los dos imports; se guarda en este navegador y aguanta un refresco. ", -1))
            ]),
            (_ctx.exportPath)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _cache[66] || (_cache[66] = _createTextVNode(" Los imports apuntarán a ", -1)),
                  _createElementVNode("code", _hoisted_51, _toDisplayString(_ctx.exportPath), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.exportStampProblem)
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _cache[67] || (_cache[67] = _createElementVNode("i", { class: "fas fa-circle-exclamation" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.exportStampProblem), 1)
                ]))
              : (!_ctx.exportStampValue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [...(_cache[68] || (_cache[68] = [
                    _createElementVNode("i", { class: "fas fa-hourglass-half" }, null, -1),
                    _createTextVNode(" Vacío mientras no se haya hecho el backup, que es lo normal al empezar. Hasta que se pegue, el comando del doble import se queda con el marcador a la vista y no se puede copiar. ", -1)
                  ]))]))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.run && !_ctx.run.writeDbId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [...(_cache[69] || (_cache[69] = [
          _createElementVNode("strong", null, [
            _createElementVNode("i", { class: "fas fa-triangle-exclamation" }),
            _createTextVNode(" Este run escribe en "),
            _createElementVNode("code", null, "(default)"),
            _createTextVNode(". ")
          ], -1),
          _createTextVNode(" En Topología A esa es la ", -1),
          _createElementVNode("strong", null, "red de rollback", -1),
          _createTextVNode(" (congelada, intacta): el barrido del paso 10 y el prune del 11 apuntados ahí mutan los 41.6k users a los que se vuelve si algo sale mal. La BD de escritura es ", -1),
          _createElementVNode("strong", null, "inmutable", -1),
          _createTextVNode(" — si esto no es lo que querías, cierra el run y abre otro con ", -1),
          _createElementVNode("code", null, "gtr-2026", -1),
          _createTextVNode(". ", -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
          _cache[70] || (_cache[70] = _createElementVNode("i", { class: "fas fa-circle-exclamation" }, null, -1)),
          (_ctx.errorStepId)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_56, "Paso " + _toDisplayString(_ctx.errorStepId), 1))
            : _createCommentVNode("", true),
          (_ctx.errorStepId)
            ? (_openBlock(), _createElementBlock("span", _hoisted_57, " — "))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.error), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.run)
      ? (_openBlock(), _createElementBlock("div", _hoisted_59, " Abre un run para empezar. El estado vive en Firestore, así que sobrevive a un refresh y dos personas ven lo mismo en paralelo. "))
      : (_openBlock(), _createElementBlock("div", _hoisted_60, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step) => {
            return (_openBlock(), _createElementBlock("div", {
              key: step.id,
              class: _normalizeClass(["card mb-2 step", [
          `step-${_ctx.statusOf(step.id)}`,
          { 'step-locked': !_ctx.unlocked(step) },
        ]])
            }, [
              _createElementVNode("div", {
                class: "card-header py-2 step-header",
                role: "button",
                tabindex: "0",
                "aria-expanded": _ctx.open[step.id] ? 'true' : 'false',
                onClick: ($event: any) => (_ctx.toggle(step.id)),
                onKeydown: [
                  _withKeys(_withModifiers(($event: any) => (_ctx.toggle(step.id)), ["prevent"]), ["enter"]),
                  _withKeys(_withModifiers(($event: any) => (_ctx.toggle(step.id)), ["prevent"]), ["space"])
                ]
              }, [
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["step-number badge", _ctx.badgeClass(_ctx.statusOf(step.id))])
                  }, _toDisplayString(step.label), 3),
                  _createElementVNode("strong", _hoisted_63, _toDisplayString(step.title), 1),
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.kindLabel(step.kind)), 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", _ctx.stepBadgeClass(step)])
                    }, _toDisplayString(_ctx.stepStatusLabel(step)), 3)
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-link p-0 ms-1 step-chevron",
                    type: "button",
                    tabindex: "-1",
                    "aria-hidden": "true",
                    onClick: _withModifiers(($event: any) => (_ctx.toggle(step.id)), ["stop"])
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fas", _ctx.open[step.id] ? 'fa-chevron-up' : 'fa-chevron-down'])
                    }, null, 2)
                  ], 8, _hoisted_66)
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("code", _hoisted_68, _toDisplayString(step.id), 1),
                  _createElementVNode("div", _hoisted_69, [
                    (step.readOnly)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_70, [...(_cache[71] || (_cache[71] = [
                          _createElementVNode("i", {
                            class: "fas fa-eye",
                            "aria-hidden": "true"
                          }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (!_ctx.isProd && step.emulator)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass(["badge", 
                  step.emulator.runs === 'no'
                    ? 'bg-secondary'
                    : 'bg-info text-dark'
                ]),
                          title: step.emulator.notInEmulator,
                          "aria-label": 
                  step.emulator.runs === 'no'
                    ? 'No aplica en el emulador'
                    : 'Aplica parcialmente en el emulador'
                
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["fas", 
                    step.emulator.runs === 'no'
                      ? 'fa-plug-circle-xmark'
                      : 'fa-plug'
                  ]),
                            "aria-hidden": "true"
                          }, null, 2),
                          (step.emulator.runs !== 'no')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_72, "Parcial"))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_71))
                      : _createCommentVNode("", true),
                    (step.emulator && step.emulator.tools?.length)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: "badge bg-light text-dark border step-tools d-inline-flex align-items-center gap-1",
                          title: _ctx.toolsTitle(step.emulator.tools),
                          "aria-label": _ctx.toolsTitle(step.emulator.tools)
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step.emulator.tools, (tool) => {
                            return (_openBlock(), _createElementBlock("i", {
                              key: tool,
                              class: _normalizeClass(["fas", _ctx.toolIcon(tool)]),
                              title: tool,
                              "aria-hidden": "true"
                            }, null, 10, _hoisted_74))
                          }), 128))
                        ], 8, _hoisted_73))
                      : _createCommentVNode("", true),
                    (_ctx.stateOf(step.id)?.durationMs)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_75, [
                          _cache[72] || (_cache[72] = _createElementVNode("i", {
                            class: "fas fa-clock",
                            "aria-hidden": "true"
                          }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.humanMs(_ctx.stateOf(step.id)?.durationMs)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 40, _hoisted_61),
              _withDirectives(_createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", {
                  class: "step-detail step-prose",
                  innerHTML: _ctx.prose(_ctx.detailForConsole(step))
                }, null, 8, _hoisted_77),
                (step.warning)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                      _cache[73] || (_cache[73] = _createElementVNode("i", { class: "fas fa-triangle-exclamation" }, null, -1)),
                      _createElementVNode("span", {
                        innerHTML: _ctx.prose(step.warning)
                      }, null, 8, _hoisted_79)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isProd && step.emulator)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _cache[74] || (_cache[74] = _createElementVNode("i", { class: "fas fa-plug-circle-xmark" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(step.emulator.runs === "no"
                  ? "Este paso NO se puede ensayar aquí"
                  : "Este paso se ensaya A MEDIAS") + " ", 1),
                        _createElementVNode("span", _hoisted_82, "— necesita " + _toDisplayString(step.emulator.tools.join(", ")), 1)
                      ]),
                      (step.emulator.inEmulator)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                            _cache[75] || (_cache[75] = _createElementVNode("b", null, "Sí aplica:", -1)),
                            _createTextVNode(" " + _toDisplayString(step.emulator.inEmulator), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_84, [
                        _cache[76] || (_cache[76] = _createElementVNode("b", null, "No aplica:", -1)),
                        _createTextVNode(" " + _toDisplayString(step.emulator.notInEmulator), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.unlocked(step))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                      _cache[77] || (_cache[77] = _createElementVNode("i", { class: "fas fa-lock" }, null, -1)),
                      _createTextVNode(" Bloqueado hasta que termine el paso " + _toDisplayString(_ctx.requiresLabels(step).join(", ")) + ". ", 1),
                      _cache[78] || (_cache[78] = _createElementVNode("em", null, "El orden no es negociable", -1)),
                      _cache[79] || (_cache[79] = _createTextVNode(" — y la callable lo rechaza igual, aunque brinques el botón. ", -1))
                    ]))
                  : _createCommentVNode("", true),
                (step.id === 'build-trees--c')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                      _cache[84] || (_cache[84] = _createStaticVNode("<div class=\"alert alert-danger py-2 mb-2\" data-v-35c969b8><strong data-v-35c969b8><i class=\"fas fa-triangle-exclamation\" data-v-35c969b8></i> Decisión de dinero — Pit decidió IMPORTAR LAS DOS (default «Sí», editables)</strong><div class=\"small mt-1\" data-v-35c969b8><strong data-v-35c969b8>Las dos banderas están decididas</strong> (Pit, 2026-07-18): se importan <code data-v-35c969b8>copyBinaryExpiration</code><em data-v-35c969b8>y</em> <code data-v-35c969b8>copyInnerLegUnlocked</code>. La consola las trae en «Sí»; puedes cambiarlas aquí, pero la decisión vigente es esa. </div><ul class=\"small mt-2 mb-0\" data-v-35c969b8><li data-v-35c969b8><code data-v-35c969b8>copyBinaryExpiration</code> — <strong data-v-35c969b8>IMPORTAR</strong>. <code data-v-35c969b8>binaryActive</code> se calcula desde <code data-v-35c969b8>binaryExpiration</code>, y <code data-v-35c969b8>placeMember</code> NUNCA lo escribe: sin arrastrarla, <strong data-v-35c969b8>toda la red</strong> queda con el binario apagado, no truena nada, y los puntos emparejados se van a <code data-v-35c969b8>lost</code> <strong data-v-35c969b8>en silencio</strong>. </li><li data-v-35c969b8><code data-v-35c969b8>copyInnerLegUnlocked</code> — <strong data-v-35c969b8>IMPORTAR</strong>. Es la power line (pierna interna) ya abierta: sin arrastrarla, los sembrados vuelven a nacer con la interna cerrada y pierden algo que ya se habían ganado. </li></ul><div class=\"small mt-2\" data-v-35c969b8> El backend las sigue exigiendo <strong data-v-35c969b8>explícitas</strong> (sin default en la callable), a propósito: la consola te dice cuál es la decisión, no la elige por ti. </div></div>", 1)),
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, [
                          _cache[81] || (_cache[81] = _createElementVNode("label", { class: "form-label small fw-bold mb-1" }, [
                            _createTextVNode(" ¿Arrastrar la calificación binaria? "),
                            _createElementVNode("span", { class: "text-muted fw-normal" }, "(copyBinaryExpiration — Pit: SÍ)")
                          ], -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.copyBinaryExpiration) = $event)),
                            class: "form-select form-select-sm"
                          }, [...(_cache[80] || (_cache[80] = [
                            _createElementVNode("option", {
                              value: null,
                              disabled: ""
                            }, "— elige —", -1),
                            _createElementVNode("option", { value: true }, "Sí — conservan la que ya se ganaron (decisión de Pit)", -1),
                            _createElementVNode("option", { value: false }, "No — todos arrancan sin binario", -1)
                          ]))], 512), [
                            [_vModelSelect, _ctx.copyBinaryExpiration]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_89, [
                          _cache[83] || (_cache[83] = _createElementVNode("label", { class: "form-label small fw-bold mb-1" }, [
                            _createTextVNode(" ¿Arrastrar la power line? "),
                            _createElementVNode("span", { class: "text-muted fw-normal" }, "(copyInnerLegUnlocked — Pit: SÍ)")
                          ], -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.copyInnerLegUnlocked) = $event)),
                            class: "form-select form-select-sm"
                          }, [...(_cache[82] || (_cache[82] = [
                            _createElementVNode("option", {
                              value: null,
                              disabled: ""
                            }, "— elige —", -1),
                            _createElementVNode("option", { value: true }, "Sí — conservan la pierna interna abierta (decisión de Pit)", -1),
                            _createElementVNode("option", { value: false }, "No — la interna nace cerrada", -1)
                          ]))], 512), [
                            [_vModelSelect, _ctx.copyInnerLegUnlocked]
                          ])
                        ])
                      ]),
                      (!_ctx.flagsChosen)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_90, " Elige las dos antes de calcular el draft. La callable las rechaza si no vienen explícitas. "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.usesAnchors(step.id))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createElementVNode("div", _hoisted_91, [
                        _cache[91] || (_cache[91] = _createElementVNode("label", { class: "form-label small fw-bold mb-1" }, [
                          _createTextVNode(" Anclas (JSON) — obligatorias "),
                          _createElementVNode("span", { class: "text-muted fw-normal" }, " founders + las ~10 colocadas a mano. Es el ÚNICO input manual del driver: sin ellas el árbol sale distinto y en silencio. Sólo aquí, en el paso 15: el reporte del 22 ya no las necesita (lee el árbol construido en vez de resolverlo). ")
                        ], -1)),
                        _createElementVNode("div", _hoisted_92, [
                          _cache[85] || (_cache[85] = _createElementVNode("span", { class: "fw-bold" }, "package", -1)),
                          _cache[86] || (_cache[86] = _createTextVNode(" — sólo estos: ", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.anchorPackages, (p) => {
                            return (_openBlock(), _createElementBlock("code", {
                              key: p,
                              class: "me-2 badge bg-light text-dark border pkg-token"
                            }, _toDisplayString(p), 1))
                          }), 128)),
                          _cache[87] || (_cache[87] = _createStaticVNode("<span class=\"text-muted\" data-v-35c969b8> · <code data-v-35c969b8>trading-academy</code> es el id de la <strong data-v-35c969b8>suscripción</strong>, NO un paquete — el paquete equivalente es <code data-v-35c969b8>gtr-fly</code> (que también es un doc-id de esa familia: no son lo mismo). Las etiquetas retiradas (<code data-v-35c969b8>gtr-basic</code>, <code data-v-35c969b8>gtr-lite</code>, <code data-v-35c969b8>gtr-vip</code>) <strong data-v-35c969b8>se siguen aceptando</strong>, pero lo que se escribe hoy es lo de arriba. Un valor desconocido lo <strong data-v-35c969b8>rechaza</strong> el backend (antes se colocaba como <code data-v-35c969b8>full</code> en silencio, con el tier equivocado). </span>", 1))
                        ]),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.anchorsJson) = $event)),
                          class: "form-control form-control-sm font-monospace",
                          rows: "7",
                          placeholder: _ctx.anchorsPlaceholder
                        }, null, 8, _hoisted_93), [
                          [_vModelText, _ctx.anchorsJson]
                        ]),
                        (_ctx.anchorsError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_94, _toDisplayString(_ctx.anchorsError), 1))
                          : _createCommentVNode("", true),
                        (_ctx.anchorsBadPackages.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                              _cache[88] || (_cache[88] = _createElementVNode("i", { class: "fas fa-ban" }, null, -1)),
                              _createTextVNode(" package inválido en " + _toDisplayString(_ctx.anchorsBadPackages.length) + " ancla(s): " + _toDisplayString(_ctx.anchorsBadPackages.join(" · ")) + ". El backend lo rechaza — no se degrada a ", 1),
                              _cache[89] || (_cache[89] = _createElementVNode("code", null, "full", -1)),
                              _cache[90] || (_cache[90] = _createTextVNode(". ", -1))
                            ]))
                          : (_ctx.anchorsCount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_96, _toDisplayString(_ctx.anchorsCount) + " ancla(s) — se sembrarán bajo la raíz. ", 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_97, " Faltan las anclas. Las trae Hector el día del go-live. "))
                      ]),
                      _createElementVNode("div", _hoisted_98, [
                        _cache[92] || (_cache[92] = _createStaticVNode("<label class=\"form-label small fw-bold mb-1\" data-v-35c969b8> Alias (JSON) — obligatorios, y DEPENDEN DEL ENTORNO <span class=\"text-muted fw-normal\" data-v-35c969b8> cuentas que son la misma persona (o la misma cuenta de empresa). <strong data-v-35c969b8>Esto es lo único que los declara</strong>: el código ya no lleva copia, así que un par que falte aquí no da error — le da a esa persona un segundo nodo, y la colocación es permanente. Uno de ellos es el rename de la raíz <code data-v-35c969b8>gtr.academy → gtr.master</code> — no lo borres. <strong data-v-35c969b8>Pega el payload del fichero de TU entorno</strong>: <code data-v-35c969b8>documentation/implementations/2026-07-26-payloads-paso15/</code> tiene <code data-v-35c969b8>alias-prod.json</code> y <code data-v-35c969b8>alias-emulador.json</code>. No son iguales: en producción hay un alias más que en el emulador no existe, y usar el del emulador allí deja a esa cuenta sin nodo, en silencio. </span></label>", 1)),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.aliasesJson) = $event)),
                          class: "form-control form-control-sm font-monospace",
                          rows: "4",
                          placeholder: _ctx.aliasesPlaceholder
                        }, null, 8, _hoisted_99), [
                          [_vModelText, _ctx.aliasesJson]
                        ]),
                        (_ctx.aliasesError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_100, _toDisplayString(_ctx.aliasesError), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_101, _toDisplayString(_ctx.aliasesCount) + " alias — su línea cuelga de la cuenta buena. ", 1))
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.stepInstances(step).length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                      _createElementVNode("div", _hoisted_103, [
                        _createElementVNode("span", _hoisted_104, [
                          _cache[93] || (_cache[93] = _createTextVNode(" Instancias del paso: ", -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass(
                    _ctx.instancesDoneCount(step) === _ctx.stepInstances(step).length
                      ? 'text-success'
                      : 'text-danger'
                  )
                          }, _toDisplayString(_ctx.instancesDoneCount(step)) + " de " + _toDisplayString(_ctx.stepInstances(step).length), 3),
                          _cache[94] || (_cache[94] = _createTextVNode(" atendidas ", -1))
                        ]),
                        _cache[95] || (_cache[95] = _createElementVNode("span", { class: "small text-muted" }, [
                          _createTextVNode(" Cada pestaña trae los campos de SU formulario, en el orden en que salen — no todas traen los mismos. Las "),
                          _createElementVNode("strong", null, "NO SE TOCA"),
                          _createTextVNode(" no traen ninguno: sólo su nota, que dice por qué están aquí. Márcala al terminarla; la marca aguanta un refresco. ")
                        ], -1))
                      ]),
                      _createElementVNode("ul", _hoisted_105, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepInstances(step), (inst) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: inst.id,
                            class: "nav-item"
                          }, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["nav-link", { active: _ctx.activeInstance(step) === inst.id }]),
                              type: "button",
                              onClick: ($event: any) => (_ctx.selectInstance(step.id, inst.id))
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass(["fas", 
                      _ctx.instanceIsDone(step.id, inst.id)
                        ? 'fa-circle-check text-success'
                        : 'fa-circle text-muted ext-pending'
                    ])
                              }, null, 2),
                              _createTextVNode(" " + _toDisplayString(inst.id), 1)
                            ], 10, _hoisted_106)
                          ]))
                        }), 128))
                      ]),
                      (_ctx.shownInstance(step))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                            _createElementVNode("div", _hoisted_108, [
                              _createElementVNode("button", {
                                class: "btn btn-sm btn-outline-secondary py-0 ext-copy-btn ext-id-copy",
                                type: "button",
                                title: 'Copiar el Instance ID: ' + _ctx.shownInstance(step).id,
                                onClick: ($event: any) => (
                    _ctx.copyText(
                      _ctx.shownInstance(step).id,
                      'ext-id-' + _ctx.shownInstance(step).id
                    )
                  )
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["fas", 
                      _ctx.copiedKey === 'ext-id-' + _ctx.shownInstance(step).id
                        ? 'fa-check'
                        : 'fa-clipboard'
                    ])
                                }, null, 2)
                              ], 8, _hoisted_109),
                              _createElementVNode("code", _hoisted_110, _toDisplayString(_ctx.shownInstance(step).id), 1),
                              (_ctx.shownInstance(step).action)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass(["badge", 
                    _ctx.actionIsHandsOff(_ctx.shownInstance(step).action)
                      ? 'ext-action-quieta'
                      : 'bg-dark'
                  ])
                                  }, [
                                    (_ctx.actionIsHandsOff(_ctx.shownInstance(step).action))
                                      ? (_openBlock(), _createElementBlock("i", _hoisted_111))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(_ctx.shownInstance(step).action), 1)
                                  ], 2))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                class: _normalizeClass(["btn btn-sm", 
                    _ctx.instanceIsDone(step.id, _ctx.shownInstance(step).id)
                      ? 'btn-success'
                      : 'btn-outline-success'
                  ]),
                                type: "button",
                                title: _ctx.instanceDoneTitle(step),
                                onClick: ($event: any) => (_ctx.toggleInstanceDone(step.id, _ctx.shownInstance(step).id))
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["fas", 
                      _ctx.instanceIsDone(step.id, _ctx.shownInstance(step).id)
                        ? 'fa-circle-check'
                        : 'fa-circle-notch'
                    ])
                                }, null, 2),
                                _createTextVNode(" " + _toDisplayString(_ctx.instanceDoneLabel(step)), 1)
                              ], 10, _hoisted_112)
                            ]),
                            (
                  _ctx.shownInstance(step).note || _ctx.shownInstance(step).params.length
                )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                  (_ctx.shownInstance(step).note)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_114, _toDisplayString(_ctx.shownInstance(step).note), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.shownInstance(step).params.length)
                                    ? (_openBlock(), _createElementBlock("table", _hoisted_115, [
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shownInstance(step).params, (prm, ix) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: prm.label + ix
                                            }, [
                                              _createElementVNode("td", _hoisted_116, [
                                                _createTextVNode(_toDisplayString(prm.label) + " ", 1),
                                                (_ctx.paramIsIrreversible(prm.label))
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_117, "irreversible"))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", _hoisted_118, [
                                                _createElementVNode("span", _hoisted_119, [
                                                  (prm.value)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        class: "btn btn-sm btn-outline-secondary py-0 ext-copy-btn",
                                                        type: "button",
                                                        title: 'Copiar el valor de ' + prm.label,
                                                        onClick: ($event: any) => (
                              _ctx.copyText(
                                _ctx.withProject(prm.value),
                                'ext-' + _ctx.shownInstance(step).id + '-' + ix
                              )
                            )
                                                      }, [
                                                        _createElementVNode("i", {
                                                          class: _normalizeClass(["fas", 
                                _ctx.copiedKey ===
                                'ext-' + _ctx.shownInstance(step).id + '-' + ix
                                  ? 'fa-check'
                                  : 'fa-clipboard'
                              ])
                                                        }, null, 2)
                                                      ], 8, _hoisted_120))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                (prm.value)
                                                  ? (_openBlock(), _createElementBlock("code", _hoisted_121, _toDisplayString(_ctx.withProject(prm.value)), 1))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_122, "(vacío)"))
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showsPointsReport(step.id))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-outline-primary",
                        disabled: _ctx.busy || !_ctx.reportUnlocked,
                        onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.runPointsReport && _ctx.runPointsReport(...args)))
                      }, [
                        (_ctx.isRunning('pointsReport'))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_125))
                          : (_openBlock(), _createElementBlock("i", _hoisted_126)),
                        _createTextVNode(" " + _toDisplayString(_ctx.isRunning("pointsReport")
                  ? "Leyendo…"
                  : "Correr el reporte (sólo lectura)"), 1)
                      ], 8, _hoisted_124),
                      _createElementVNode("span", _hoisted_127, [
                        _cache[96] || (_cache[96] = _createTextVNode(" No escribe nada, en ninguna de las dos bases: lee los puntos de ", -1)),
                        _cache[97] || (_cache[97] = _createElementVNode("code", null, "legacy-2026", -1)),
                        _cache[98] || (_cache[98] = _createTextVNode(" y quién quedó colocado de ", -1)),
                        _createElementVNode("code", null, _toDisplayString(_ctx.run?.writeDbId || "(default)"), 1),
                        _cache[99] || (_cache[99] = _createTextVNode(". ", -1))
                      ]),
                      (_ctx.pointsReport)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                            _createElementVNode("div", _hoisted_129, [
                              _createElementVNode("button", {
                                class: "btn btn-sm btn-outline-secondary",
                                disabled: _ctx.busy || !_ctx.reportUnlocked,
                                title: "Vuelve a leer las dos bases. No escribe nada.",
                                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.runPointsReport && _ctx.runPointsReport(...args)))
                              }, [
                                _cache[100] || (_cache[100] = _createElementVNode("i", { class: "fas fa-arrows-rotate" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.isRunning("pointsReport") ? "Leyendo…" : "Refrescar"), 1)
                              ], 8, _hoisted_130),
                              _createElementVNode("span", _hoisted_131, "Foto de las " + _toDisplayString(_ctx.reportTakenAt()) + ".", 1)
                            ]),
                            _createElementVNode("div", _hoisted_132, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.puntos(_ctx.pointsReport.totals.accounts)), 1),
                              _cache[101] || (_cache[101] = _createTextVNode(" cuentas COLOCADAS · ", -1)),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.puntos(_ctx.pointsReport.totals.inverted)), 1),
                              _cache[102] || (_cache[102] = _createTextVNode(" con el lado cambiado · ", -1)),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.puntos(_ctx.pointsReport.totals.binaryPending)), 1),
                              _cache[103] || (_cache[103] = _createStaticVNode(" puntos de binario vivos. <div class=\"mt-1\" data-v-35c969b8> Cada cuenta trae lo mismo de los dos árboles: el <strong data-v-35c969b8>lado</strong> en el que está, y sus puntos por <strong data-v-35c969b8>derrame / interna</strong> y por <strong data-v-35c969b8>izquierda / derecha</strong>. Cuando los dos <strong data-v-35c969b8>lados</strong> no coinciden, la fila lleva <span class=\"pr-swap\" data-v-35c969b8><i class=\"fas fa-right-left\" data-v-35c969b8></i></span> — esa persona cambió de pierna. </div><div class=\"mt-1\" data-v-35c969b8><strong data-v-35c969b8>El árbol nuevo empieza en ceros</strong>, y eso ya dice algo: son las cuentas a las que todavía no se les han pasado los puntos. Según se van aplicando, sus cifras aparecen — y ahí es cuando las dos últimas columnas se comparan de verdad: a quien cambió de pierna, lo que tenía en la izquierda del árbol viejo tiene que aparecerle en la derecha del nuevo. </div><div class=\"mt-1\" data-v-35c969b8><strong data-v-35c969b8>El rango no sale.</strong> Los puntos de binario se trasladan, pero el rango recalifica desde cero: el volumen de rango del corte no se le devuelve a nadie, así que enseñarlo aquí sólo podía invitar a restituirlo. </div>", 4))
                            ]),
                            (_ctx.pointsReport.placedWithoutLegacy.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                                  _cache[104] || (_cache[104] = _createElementVNode("i", { class: "fas fa-triangle-exclamation" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.pointsReport.placedWithoutLegacy.length) + " cuenta(s) colocadas SIN documento en ", 1),
                                  _cache[105] || (_cache[105] = _createElementVNode("code", null, "legacy-2026", -1)),
                                  _cache[106] || (_cache[106] = _createTextVNode(" — ", -1)),
                                  _createElementVNode("code", null, _toDisplayString(_ctx.pointsReport.placedWithoutLegacy.join(" · ")), 1),
                                  _cache[107] || (_cache[107] = _createTextVNode(". Normal en un sembrado nuevo (", -1)),
                                  _cache[108] || (_cache[108] = _createElementVNode("code", null, "gtr.master", -1)),
                                  _cache[109] || (_cache[109] = _createTextVNode("): sus ceros son reales, no un fallo de lectura. ", -1))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.pointsReport.nodesWithoutSide.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                  _createTextVNode(_toDisplayString(_ctx.pointsReport.nodesWithoutSide.length) + " doc(s) de ", 1),
                                  _cache[110] || (_cache[110] = _createElementVNode("code", null, "binaryTree", -1)),
                                  _cache[111] || (_cache[111] = _createTextVNode(" sin ", -1)),
                                  _cache[112] || (_cache[112] = _createElementVNode("code", null, "binarySide", -1)),
                                  _cache[113] || (_cache[113] = _createTextVNode(" — ", -1)),
                                  _createElementVNode("code", null, _toDisplayString(_ctx.pointsReport.nodesWithoutSide.join(" · ")), 1),
                                  _cache[114] || (_cache[114] = _createTextVNode(". Es el backlink del ápice, no un miembro colocado. ", -1))
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_135, [
                              _createElementVNode("table", _hoisted_136, [
                                _cache[123] || (_cache[123] = _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, "cuenta"),
                                    _createElementVNode("th", { class: "text-center" }, [
                                      _createTextVNode(" lado"),
                                      _createElementVNode("span", { class: "pr-th-sub" }, "árbol nuevo")
                                    ]),
                                    _createElementVNode("th", { class: "text-center" }, [
                                      _createTextVNode(" derrame"),
                                      _createElementVNode("span", { class: "pr-th-sub" }, "árbol nuevo")
                                    ]),
                                    _createElementVNode("th", { class: "text-center" }, [
                                      _createTextVNode(" interna"),
                                      _createElementVNode("span", { class: "pr-th-sub" }, "árbol nuevo")
                                    ]),
                                    _createElementVNode("th", { class: "text-center pr-sep pr-viejo" }, [
                                      _createTextVNode(" lado"),
                                      _createElementVNode("span", { class: "pr-th-sub" }, "árbol viejo")
                                    ]),
                                    _createElementVNode("th", { class: "text-center pr-viejo" }, [
                                      _createTextVNode(" derrame"),
                                      _createElementVNode("span", { class: "pr-th-sub" }, "árbol viejo")
                                    ]),
                                    _createElementVNode("th", { class: "text-center pr-viejo" }, [
                                      _createTextVNode(" interna"),
                                      _createElementVNode("span", { class: "pr-th-sub" }, "árbol viejo")
                                    ]),
                                    _createElementVNode("th", {
                                      class: "text-center pr-sep",
                                      title: "legacy-2026 · binary-tree/{cuenta}.points — tal y como está guardado, sin tocar."
                                    }, [
                                      _createTextVNode(" puntos"),
                                      _createElementVNode("span", { class: "pr-th-sub" }, "árbol viejo")
                                    ]),
                                    _createElementVNode("th", { class: "text-center pr-th-pierna" }, "pierna"),
                                    _createElementVNode("th", {
                                      class: "text-center",
                                      title: "gtr-2026 · binaryTree/{cuenta}.points — lo que hay escrito ahora mismo. En ceros hasta que se aplica el import."
                                    }, [
                                      _createTextVNode(" puntos"),
                                      _createElementVNode("span", { class: "pr-th-sub" }, "árbol nuevo")
                                    ]),
                                    _createElementVNode("th", null, "importar")
                                  ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pointsReport.rows.slice(0, 50), (row, i) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                      key: row.usernamePK
                                    }, [
                                      _createElementVNode("tr", {
                                        class: _normalizeClass(["pr-acct-start", {
                          'pr-flipped': row.inverted,
                          'pr-alt': i % 2 === 1,
                        }])
                                      }, [
                                        _createElementVNode("td", _hoisted_137, [
                                          _createElementVNode("code", null, _toDisplayString(row.usernamePK), 1),
                                          (!row.legacyPresent)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_138, "sin legacy"))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("td", _hoisted_139, [
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["pr-side", _ctx.sideClass(row.resolvedBinarySide)]),
                                            title: _ctx.sideTitle(row.resolvedBinarySide, 'nuevo')
                                          }, _toDisplayString(_ctx.sideLetter(row.resolvedBinarySide)), 11, _hoisted_140),
                                          (row.inverted)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_141, [...(_cache[115] || (_cache[115] = [
                                                _createElementVNode("i", { class: "fas fa-right-left" }, null, -1)
                                              ]))]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("td", _hoisted_142, _toDisplayString(_ctx.puntosOpt(_ctx.derrameNow(row))), 1),
                                        _createElementVNode("td", _hoisted_143, _toDisplayString(_ctx.puntosOpt(_ctx.internaNow(row))), 1),
                                        _createElementVNode("td", _hoisted_144, [
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["pr-side", _ctx.sideClass(row.legacyBinarySide)]),
                                            title: _ctx.sideTitle(row.legacyBinarySide, 'viejo')
                                          }, _toDisplayString(_ctx.sideLetter(row.legacyBinarySide)), 11, _hoisted_145)
                                        ]),
                                        _createElementVNode("td", _hoisted_146, _toDisplayString(_ctx.puntos(_ctx.derramePoints(row))), 1),
                                        _createElementVNode("td", _hoisted_147, _toDisplayString(_ctx.puntos(_ctx.internaPoints(row))), 1),
                                        _createElementVNode("td", _hoisted_148, [
                                          _createTextVNode(_toDisplayString(_ctx.puntosOpt(_ctx.viejoLeft(row))) + " ", 1),
                                          (_ctx.cuadreLeg(row.usernamePK, 'viejo', 'left'))
                                            ? (_openBlock(), _createElementBlock("i", {
                                                key: 0,
                                                class: "fas fa-scale-unbalanced text-danger pr-descuadre",
                                                role: "button",
                                                tabindex: "0",
                                                title: 
                              _ctx.cuadreCeldaTitulo(row.usernamePK, 'viejo', 'left')
                            ,
                                                "aria-label": 
                              _ctx.cuadreCeldaTitulo(row.usernamePK, 'viejo', 'left')
                            ,
                                                onClick: ($event: any) => (_ctx.verCuadre(row.usernamePK)),
                                                onKeydown: _withKeys(($event: any) => (_ctx.verCuadre(row.usernamePK)), ["enter"])
                                              }, null, 40, _hoisted_149))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _cache[121] || (_cache[121] = _createElementVNode("td", { class: "text-center pr-leg-a" }, [
                                          _createElementVNode("span", { class: "pr-leg-tag" }, "Izq")
                                        ], -1)),
                                        _createElementVNode("td", _hoisted_150, [
                                          _createTextVNode(_toDisplayString(_ctx.puntosOpt(_ctx.nuevoLeft(row))) + " ", 1),
                                          (_ctx.cuadreLeg(row.usernamePK, 'nuevo', 'left'))
                                            ? (_openBlock(), _createElementBlock("i", {
                                                key: 0,
                                                class: "fas fa-scale-unbalanced text-danger pr-descuadre",
                                                role: "button",
                                                tabindex: "0",
                                                title: 
                              _ctx.cuadreCeldaTitulo(row.usernamePK, 'nuevo', 'left')
                            ,
                                                "aria-label": 
                              _ctx.cuadreCeldaTitulo(row.usernamePK, 'nuevo', 'left')
                            ,
                                                onClick: ($event: any) => (_ctx.verCuadre(row.usernamePK)),
                                                onKeydown: _withKeys(($event: any) => (_ctx.verCuadre(row.usernamePK)), ["enter"])
                                              }, null, 40, _hoisted_151))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("td", _hoisted_152, [
                                          (_ctx.reportConfirmed())
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_153, [...(_cache[116] || (_cache[116] = [
                                                _createElementVNode("i", { class: "fas fa-lock" }, null, -1),
                                                _createTextVNode(" confirmado", -1)
                                              ]))]))
                                            : (_ctx.rowBlockedReason(row))
                                              ? (_openBlock(), _createElementBlock("span", {
                                                  key: 1,
                                                  class: "badge bg-light text-dark border",
                                                  title: _ctx.rowBlockedReason(row)
                                                }, _toDisplayString(_ctx.rowBlockedReason(row)), 9, _hoisted_154))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_155, [
                                                  _createElementVNode("div", _hoisted_156, [
                                                    (!_ctx.esARevisar(row))
                                                      ? (_openBlock(), _createElementBlock("button", {
                                                          key: 0,
                                                          class: "btn btn-sm btn-outline-success",
                                                          disabled: 
                                    _ctx.busy ||
                                    !!_ctx.applyDisabledReason(row.usernamePK)
                                  ,
                                                          title: 
                                    _ctx.applyDisabledReason(row.usernamePK) ||
                                    'Copia sus registros vigentes desde legacy-2026.'
                                  ,
                                                          onClick: ($event: any) => (_ctx.importRow(row.usernamePK, 'apply'))
                                                        }, _toDisplayString(_ctx.isRunning(`import:apply:${row.usernamePK}`)
                                      ? "Aplicando…"
                                      : "Aplicar"), 9, _hoisted_157))
                                                      : _createCommentVNode("", true),
                                                    _createElementVNode("button", {
                                                      class: "btn btn-sm btn-outline-danger",
                                                      disabled: 
                                    _ctx.busy || !_ctx.importBorrable(row.usernamePK)
                                  ,
                                                      title: 
                                    _ctx.undoDisabledReason(row.usernamePK) ||
                                    'Borra SÓLO los documentos que este import escribió.'
                                  ,
                                                      onClick: ($event: any) => (_ctx.importRow(row.usernamePK, 'undo'))
                                                    }, _toDisplayString(_ctx.isRunning(`import:undo:${row.usernamePK}`)
                                      ? "Borrando…"
                                      : "Borrar"), 9, _hoisted_158),
                                                    (_ctx.rowWarningReason(row))
                                                      ? (_openBlock(), _createElementBlock("span", {
                                                          key: 1,
                                                          class: "badge pr-badge-ojo",
                                                          title: _ctx.rowWarningReason(row)
                                                        }, [...(_cache[117] || (_cache[117] = [
                                                          _createElementVNode("i", { class: "fas fa-triangle-exclamation" }, null, -1),
                                                          _createTextVNode(" ojo: puede duplicar", -1)
                                                        ]))], 8, _hoisted_159))
                                                      : _createCommentVNode("", true),
                                                    (
                                    _ctx.esARevisar(row) &&
                                    _ctx.importApplied(row.usernamePK)
                                  )
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_160, "aplicada en falso"))
                                                      : (!_ctx.esARevisar(row))
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                            (_ctx.importStale(row.usernamePK))
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_161, "inválida: rehaz"))
                                                              : (_ctx.importApplying(row.usernamePK))
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_162, "a medio aplicar"))
                                                                : (_ctx.importApplied(row.usernamePK))
                                                                  ? (_openBlock(), _createElementBlock("span", {
                                                                      key: 2,
                                                                      class: "badge bg-success",
                                                                      title: _ctx.importSummary(row.usernamePK)
                                                                    }, "aplicado", 8, _hoisted_163))
                                                                  : _createCommentVNode("", true)
                                                          ], 64))
                                                        : _createCommentVNode("", true)
                                                  ]),
                                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['interna', 'derrame'], (et) => {
                                                    return _createElementVNode("div", {
                                                      key: et,
                                                      class: "pr-crear"
                                                    }, [
                                                      _createElementVNode("div", _hoisted_164, [
                                                        _createElementVNode("span", _hoisted_165, _toDisplayString(et), 1),
                                                        _createElementVNode("span", {
                                                          class: _normalizeClass(["pr-fuente", {
                                      'pr-fuente-difiere': _ctx.fuentesDifieren(
                                        row,
                                        et
                                      ),
                                    }]),
                                                          title: "Lo que DECLARA el nodo de legacy-2026 en esa pierna. Es un acumulado: no lo sostiene ningún documento."
                                                        }, [
                                                          _cache[118] || (_cache[118] = _createTextVNode("summary ", -1)),
                                                          _createElementVNode("b", null, _toDisplayString(_ctx.puntos(_ctx.summaryDe(row, et))), 1)
                                                        ], 2),
                                                        _createElementVNode("span", {
                                                          class: _normalizeClass(["pr-fuente pr-fuente-con", {
                                      'pr-fuente-difiere': _ctx.fuentesDifieren(
                                        row,
                                        et
                                      ),
                                    }]),
                                                          title: "Lo que suman sus REGISTROS VIVOS, ya puestos en la pierna del árbol nuevo. Es lo que copiaría «Aplicar», y con lo que nace la caja."
                                                        }, [
                                                          _cache[119] || (_cache[119] = _createTextVNode("consolidado ", -1)),
                                                          _createElementVNode("b", null, _toDisplayString(_ctx.puntos(_ctx.consolidadoDe(row, et))), 1)
                                                        ], 2),
                                                        (
                                      _ctx.esPiernaInfinita(row) && et === 'derrame'
                                    )
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_166, "concesión"))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_167, [
                                                        _createElementVNode("input", {
                                                          type: "number",
                                                          class: _normalizeClass(["form-control form-control-sm pr-crear-monto", {
                                      'pr-crear-monto-xl':
                                        _ctx.montoDe(row, et) >= 1000000,
                                    }]),
                                                          value: _ctx.montoDe(row, et),
                                                          min: "1",
                                                          step: "1",
                                                          "aria-label": `Puntos a crear en la ${et} de ${row.usernamePK}`,
                                                          onInput: ($event: any) => (
                                      _ctx.setMonto(row, et, $event.target.value)
                                    )
                                                        }, null, 42, _hoisted_168),
                                                        _createElementVNode("button", {
                                                          class: "btn btn-sm btn-outline-primary",
                                                          disabled: _ctx.busy || !_ctx.montoDe(row, et),
                                                          title: `Crea ${_ctx.montoDe(
                                      row,
                                      et
                                    ).toLocaleString()} puntos en su ${et}. Se SUMAN a lo que la pierna ya tenga.`,
                                                          onClick: ($event: any) => (_ctx.crearPuntos(row, et))
                                                        }, _toDisplayString(_ctx.isRunning(`crear:${et}:${row.usernamePK}`)
                                        ? "Creando…"
                                        : `Crear ${et}`), 9, _hoisted_169)
                                                      ])
                                                    ])
                                                  }), 64)),
                                                  (_ctx.esARevisar(row))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_170, [...(_cache[120] || (_cache[120] = [
                                                        _createElementVNode("i", { class: "fas fa-triangle-exclamation" }, null, -1),
                                                        _createElementVNode("strong", null, "a revisar", -1),
                                                        _createTextVNode(" — el nodo declara más de lo que respaldan sus registros, así que no hay «Aplicar»: lo que falte se crea a mano. ", -1)
                                                      ]))]))
                                                    : _createCommentVNode("", true)
                                                ]))
                                        ])
                                      ], 2),
                                      _createElementVNode("tr", {
                                        class: _normalizeClass({
                          'pr-flipped': row.inverted,
                          'pr-alt': i % 2 === 1,
                        })
                                      }, [
                                        _createElementVNode("td", _hoisted_171, [
                                          _createTextVNode(_toDisplayString(_ctx.puntosOpt(_ctx.viejoRight(row))) + " ", 1),
                                          (_ctx.cuadreLeg(row.usernamePK, 'viejo', 'right'))
                                            ? (_openBlock(), _createElementBlock("i", {
                                                key: 0,
                                                class: "fas fa-scale-unbalanced text-danger pr-descuadre",
                                                role: "button",
                                                tabindex: "0",
                                                title: 
                              _ctx.cuadreCeldaTitulo(
                                row.usernamePK,
                                'viejo',
                                'right'
                              )
                            ,
                                                "aria-label": 
                              _ctx.cuadreCeldaTitulo(
                                row.usernamePK,
                                'viejo',
                                'right'
                              )
                            ,
                                                onClick: ($event: any) => (_ctx.verCuadre(row.usernamePK)),
                                                onKeydown: _withKeys(($event: any) => (_ctx.verCuadre(row.usernamePK)), ["enter"])
                                              }, null, 40, _hoisted_172))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _cache[122] || (_cache[122] = _createElementVNode("td", { class: "text-center" }, [
                                          _createElementVNode("span", { class: "pr-leg-tag" }, "Der")
                                        ], -1)),
                                        _createElementVNode("td", _hoisted_173, [
                                          _createTextVNode(_toDisplayString(_ctx.puntosOpt(_ctx.nuevoRight(row))) + " ", 1),
                                          (_ctx.cuadreLeg(row.usernamePK, 'nuevo', 'right'))
                                            ? (_openBlock(), _createElementBlock("i", {
                                                key: 0,
                                                class: "fas fa-scale-unbalanced text-danger pr-descuadre",
                                                role: "button",
                                                tabindex: "0",
                                                title: 
                              _ctx.cuadreCeldaTitulo(
                                row.usernamePK,
                                'nuevo',
                                'right'
                              )
                            ,
                                                "aria-label": 
                              _ctx.cuadreCeldaTitulo(
                                row.usernamePK,
                                'nuevo',
                                'right'
                              )
                            ,
                                                onClick: ($event: any) => (_ctx.verCuadre(row.usernamePK)),
                                                onKeydown: _withKeys(($event: any) => (_ctx.verCuadre(row.usernamePK)), ["enter"])
                                              }, null, 40, _hoisted_174))
                                            : _createCommentVNode("", true)
                                        ])
                                      ], 2)
                                    ], 64))
                                  }), 128))
                                ])
                              ])
                            ]),
                            (_ctx.pointsReport.rows.length > 50)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_175, " Se pintan las 50 primeras de " + _toDisplayString(_ctx.pointsReport.rows.length) + ": primero las que cambiaron de pierna, y después por puntos de binario vivos. El JSON de abajo las trae todas. ", 1))
                              : _createCommentVNode("", true),
                            (_ctx.pointsReport.cuadre && !_ctx.pointsReport.cuadre.ok)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 3,
                                  class: _normalizeClass(["alert py-2 small mb-2", 
                  _ctx.cuadreNuevos().length ? 'alert-danger' : 'alert-warning'
                ])
                                }, [
                                  _createElementVNode("div", _hoisted_176, [
                                    _createElementVNode("span", null, [
                                      _cache[124] || (_cache[124] = _createElementVNode("i", { class: "fas fa-scale-unbalanced" }, null, -1)),
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.cuadreMismatches().length), 1),
                                      _createTextVNode(" pierna(s) descuadran de " + _toDisplayString(_ctx.pointsReport.cuadre.checkedLegs) + " comprobadas: ", 1),
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.cuadreNuevos().length), 1),
                                      _cache[125] || (_cache[125] = _createTextVNode(" del árbol NUEVO · ", -1)),
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.cuadreViejos().length), 1),
                                      _cache[126] || (_cache[126] = _createTextVNode(" del VIEJO. ", -1))
                                    ]),
                                    _createElementVNode("button", {
                                      class: "btn btn-sm btn-outline-dark",
                                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.verCuadre()))
                                    }, " Ver el descuadre ")
                                  ]),
                                  (_ctx.cuadreNuevos().length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_177, " Las del árbol NUEVO se arreglan aquí mismo (Borrar, y volver a importar o crear). No se puede confirmar con ellas encima. "))
                                    : _createCommentVNode("", true),
                                  (_ctx.cuadreViejos().length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_178, " Las del árbol VIEJO no se arreglan: esa base está congelada. Se decide a mano cuánto se restituye, y se reconocen al firmar. "))
                                    : _createCommentVNode("", true)
                                ], 2))
                              : _createCommentVNode("", true),
                            (!_ctx.reportConfirmed())
                              ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                                  (_ctx.cuadreViejos().length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                                        _withDirectives(_createElementVNode("input", {
                                          id: "ackCuadreViejo",
                                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.ackCuadreViejo) = $event)),
                                          class: "form-check-input",
                                          type: "checkbox"
                                        }, null, 512), [
                                          [_vModelCheckbox, _ctx.ackCuadreViejo]
                                        ]),
                                        _createElementVNode("label", _hoisted_181, [
                                          _cache[127] || (_cache[127] = _createTextVNode(" He mirado los ", -1)),
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.cuadreViejos().length), 1),
                                          _cache[128] || (_cache[128] = _createTextVNode(" descuadre(s) del árbol VIEJO y los reconozco. Quedan escritos en la foto, con cuenta y pierna. ", -1))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-primary",
                                    disabled: _ctx.busy || !!_ctx.confirmBlockedReason(),
                                    title: 
                    _ctx.confirmBlockedReason() ||
                    'Vuelve a leer las dos bases, comprueba el cuadre y guarda el resultado.'
                  ,
                                    onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.confirmPointsReport && _ctx.confirmPointsReport(...args)))
                                  }, [
                                    _cache[129] || (_cache[129] = _createElementVNode("i", { class: "fas fa-lock" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.isRunning("confirmPoints")
                      ? "Confirmando…"
                      : "Refrescar y confirmar datos"), 1)
                                  ], 8, _hoisted_182),
                                  (_ctx.confirmBlockedReason())
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_183, _toDisplayString(_ctx.confirmBlockedReason()), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_184, " Relee, cuadra y GUARDA. Después no se puede accionar nada — para volver a tocar hay que cancelar. "))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_185, [
                                  _createElementVNode("span", _hoisted_186, [
                                    _cache[130] || (_cache[130] = _createElementVNode("i", { class: "fas fa-lock" }, null, -1)),
                                    _cache[131] || (_cache[131] = _createElementVNode("strong", null, "Datos confirmados", -1)),
                                    _cache[132] || (_cache[132] = _createTextVNode(" por ", -1)),
                                    _createElementVNode("code", null, _toDisplayString(_ctx.pointsConfirmation.confirmedBy), 1),
                                    _createTextVNode(" el " + _toDisplayString(_ctx.reportConfirmedAt()) + " · validación nº " + _toDisplayString(_ctx.pointsConfirmation.attempt) + " · foto de " + _toDisplayString(_ctx.puntos(_ctx.pointsConfirmation.sizeBytes || 0)) + " bytes. ", 1),
                                    ((_ctx.pointsConfirmation.ackViejo || []).length)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(" Se reconocieron " + _toDisplayString((_ctx.pointsConfirmation.ackViejo || []).length) + " descuadre(s) del árbol viejo. ", 1)
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    _cache[133] || (_cache[133] = _createTextVNode(" Ya se puede marcar el paso como hecho. ", -1))
                                  ]),
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-danger",
                                    disabled: _ctx.busy,
                                    title: "Borra la foto y devuelve los botones para poder volver a validar.",
                                    onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.cancelPointsReport && _ctx.cancelPointsReport(...args)))
                                  }, _toDisplayString(_ctx.isRunning("cancelPoints") ? "Cancelando…" : "Cancelar"), 9, _hoisted_187)
                                ])),
                            (_ctx.cuadreVistas)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 6,
                                  class: "pr-cuadre-overlay",
                                  onClick: _cache[23] || (_cache[23] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cerrarCuadre && _ctx.cerrarCuadre(...args)), ["self"]))
                                }, [
                                  _createElementVNode("div", _hoisted_188, [
                                    _createElementVNode("div", _hoisted_189, [
                                      _createElementVNode("strong", _hoisted_190, "Descuadre resumen / consolidado — " + _toDisplayString(_ctx.cuadreTitulo), 1),
                                      _createElementVNode("button", {
                                        class: "btn btn-sm btn-outline-secondary",
                                        onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.cerrarCuadre && _ctx.cerrarCuadre(...args)))
                                      }, " Cerrar ")
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cuadreVistas, (m) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: m.usernamePK + m.tree + m.leg,
                                        class: "mb-3"
                                      }, [
                                        _createElementVNode("div", _hoisted_191, [
                                          _createElementVNode("code", null, _toDisplayString(m.usernamePK), 1),
                                          _cache[134] || (_cache[134] = _createTextVNode(" · ", -1)),
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.cuadreArbol(m)), 1),
                                          _cache[135] || (_cache[135] = _createTextVNode(" · pierna ", -1)),
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.cuadrePierna(m)), 1)
                                        ]),
                                        _createElementVNode("table", _hoisted_192, [
                                          _cache[142] || (_cache[142] = _createElementVNode("thead", null, [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("th"),
                                              _createElementVNode("th", { class: "text-end pe-3" }, "summary"),
                                              _createElementVNode("th", { class: "text-end pe-3" }, "consolidado"),
                                              _createElementVNode("th")
                                            ])
                                          ], -1)),
                                          _createElementVNode("tbody", null, [
                                            _createElementVNode("tr", _hoisted_193, [
                                              _cache[137] || (_cache[137] = _createElementVNode("td", null, [
                                                _createElementVNode("strong", null, "pending")
                                              ], -1)),
                                              _createElementVNode("td", _hoisted_194, _toDisplayString(_ctx.puntos(m.resumen.pending)), 1),
                                              _createElementVNode("td", _hoisted_195, _toDisplayString(_ctx.puntos(m.consolidado.pending)), 1),
                                              _createElementVNode("td", null, [
                                                _cache[136] || (_cache[136] = _createTextVNode(" ← descuadra: ", -1)),
                                                _createElementVNode("strong", null, _toDisplayString(_ctx.cuadreDiferencia(m)), 1)
                                              ])
                                            ]),
                                            _createElementVNode("tr", null, [
                                              _cache[138] || (_cache[138] = _createElementVNode("td", null, "paid", -1)),
                                              _createElementVNode("td", _hoisted_196, _toDisplayString(_ctx.puntos(m.resumen.paid)), 1),
                                              _createElementVNode("td", _hoisted_197, _toDisplayString(_ctx.puntos(m.consolidado.paid)), 1),
                                              _cache[139] || (_cache[139] = _createElementVNode("td", { class: "text-muted" }, "—", -1))
                                            ]),
                                            _createElementVNode("tr", null, [
                                              _cache[140] || (_cache[140] = _createElementVNode("td", null, "lost", -1)),
                                              _createElementVNode("td", _hoisted_198, _toDisplayString(_ctx.puntos(m.resumen.lost)), 1),
                                              _createElementVNode("td", _hoisted_199, _toDisplayString(_ctx.puntos(m.consolidado.lost)), 1),
                                              _cache[141] || (_cache[141] = _createElementVNode("td", { class: "text-muted" }, "—", -1))
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_200, [
                                          (m.idsTotal)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(_toDisplayString(m.idsTotal) + " registro(s) vivo(s): ", 1),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.ids, (id) => {
                                                  return (_openBlock(), _createElementBlock("code", {
                                                    key: id,
                                                    class: "me-2"
                                                  }, _toDisplayString(id), 1))
                                                }), 128)),
                                                (m.idsTotal > m.ids.length)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_201, "…"))
                                                  : _createCommentVNode("", true)
                                              ], 64))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createTextVNode(" Ni un registro vivo detrás de esta pierna. ")
                                              ], 64)),
                                          (m.deadRecords)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_202, " · " + _toDisplayString(m.deadRecords) + " muerto(s).", 1))
                                            : _createCommentVNode("", true),
                                          (m.summaryDoc)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_203, [
                                                _cache[143] || (_cache[143] = _createTextVNode(" · el doc ", -1)),
                                                _cache[144] || (_cache[144] = _createElementVNode("code", null, "binaryPoints-summary", -1)),
                                                _createTextVNode(" dice " + _toDisplayString(_ctx.puntos(m.summaryDoc.pending)) + ".", 1)
                                              ]))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_204, [...(_cache[145] || (_cache[145] = [
                                                _createTextVNode(" · sin doc ", -1),
                                                _createElementVNode("code", null, "binaryPoints-summary", -1),
                                                _createTextVNode(".", -1)
                                              ]))]))
                                        ])
                                      ]))
                                    }), 128)),
                                    _cache[146] || (_cache[146] = _createElementVNode("div", { class: "small text-muted border-top pt-2" }, [
                                      _createTextVNode(" Sólo "),
                                      _createElementVNode("code", null, "pending"),
                                      _createTextVNode(" cuadra: el nodo no mantiene "),
                                      _createElementVNode("code", null, "paid"),
                                      _createTextVNode(" ni "),
                                      _createElementVNode("code", null, "lost"),
                                      _createTextVNode(" contra el detalle. ")
                                    ], -1))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (step.id === _ctx.catalogStepId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-outline-primary",
                        disabled: _ctx.busy || !_ctx.unlocked(step),
                        onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.runVerifyCatalog && _ctx.runVerifyCatalog(...args)))
                      }, [
                        (_ctx.isRunning('verifyCatalog'))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_207))
                          : (_openBlock(), _createElementBlock("i", _hoisted_208)),
                        _createTextVNode(" " + _toDisplayString(_ctx.isRunning("verifyCatalog")
                  ? "Leyendo…"
                  : "Leer el catálogo (sólo lectura)"), 1)
                      ], 8, _hoisted_206),
                      _createElementVNode("span", _hoisted_209, [
                        _cache[147] || (_cache[147] = _createTextVNode(" No escribe nada. Lee los diez documentos de ", -1)),
                        _cache[148] || (_cache[148] = _createElementVNode("code", null, "subscriptions", -1)),
                        _cache[149] || (_cache[149] = _createTextVNode(" en ", -1)),
                        _createElementVNode("code", null, _toDisplayString(_ctx.run?.writeDbId || "(default)"), 1),
                        _cache[150] || (_cache[150] = _createTextVNode(", que es la base de la que va a leer el paso que construye los árboles. ", -1))
                      ]),
                      (_ctx.catalogReport)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_210, [
                            _createVNode(_component_CatalogCheck, { report: _ctx.catalogReport }, null, 8, ["report"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (step.id === _ctx.cofounderStepId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_211, [
                      _createElementVNode("div", _hoisted_212, [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-outline-primary",
                          disabled: _ctx.busy || !_ctx.cofounderUnlocked,
                          title: "Relee `users/{u}.currentRank` y `binaryTree/{u}.binaryPercentage` de las cuentas fundadoras. No escribe nada y no marca el paso.",
                          onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.readCofounderRanks && _ctx.readCofounderRanks(...args)))
                        }, [
                          _cache[151] || (_cache[151] = _createElementVNode("i", { class: "fas fa-crown" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.isRunning("cofounder:read")
                    ? "Leyendo…"
                    : _ctx.cofounderReport
                    ? "Refrescar la tabla"
                    : "Leer los fundadores (sólo lectura)"), 1)
                        ], 8, _hoisted_213),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-success",
                          disabled: 
                  _ctx.busy || !_ctx.cofounderUnlocked || !!_ctx.cofounderApplyDisabledReason
                ,
                          title: 
                  _ctx.cofounderApplyDisabledReason ||
                  `Ejecuta el paso sobre las ${_ctx.cofounderSelection.length} cuenta(s) marcada(s): rango y porcentaje de binario, los dos, en la base del run.`
                ,
                          onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.applyCofounderRanks && _ctx.applyCofounderRanks(...args)))
                        }, [
                          (_ctx.isRunning(_ctx.autoAction(_ctx.cofounderStepId, false)))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_215))
                            : (_openBlock(), _createElementBlock("i", _hoisted_216)),
                          _createTextVNode(" " + _toDisplayString(_ctx.isRunning(_ctx.autoAction(_ctx.cofounderStepId, false))
                    ? "Aplicando…"
                    : _ctx.cofounderSelection.length
                    ? `Aplicar (${_ctx.cofounderSelection.length})`
                    : "Aplicar"), 1)
                        ], 8, _hoisted_214)
                      ]),
                      _createElementVNode("div", _hoisted_217, [
                        _cache[152] || (_cache[152] = _createTextVNode(" Escribe SÓLO en ", -1)),
                        _createElementVNode("code", null, _toDisplayString(_ctx.run?.writeDbId || "(default)"), 1),
                        _cache[153] || (_cache[153] = _createTextVNode(", la base de este run, y SÓLO sobre las cuentas marcadas. ", -1)),
                        _cache[154] || (_cache[154] = _createElementVNode("code", null, "(default)", -1)),
                        _cache[155] || (_cache[155] = _createTextVNode(" es la red de rollback: nada de esto llega ahí. ", -1))
                      ]),
                      (_ctx.cofounderReport)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_218, [
                            _createVNode(_component_CofounderRanks, {
                              report: _ctx.cofounderReport,
                              writes: _ctx.cofounderWrites,
                              selected: _ctx.cofounderSelection,
                              onToggle: _ctx.toggleCofounder
                            }, null, 8, ["report", "writes", "selected", "onToggle"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (step.kind === 'pre')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_219, [
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-outline-secondary",
                        disabled: _ctx.busy || !_ctx.unlocked(step) || _ctx.isDone(step.id),
                        title: "Este paso no aplica en este run. Queda como `skipped`, que desbloquea igual que «hecho».",
                        onClick: ($event: any) => (_ctx.completeManual(step.id, true))
                      }, [
                        (_ctx.isRunning(_ctx.manualAction(step.id, true)))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_221))
                          : (_openBlock(), _createElementBlock("i", _hoisted_222)),
                        _createTextVNode(" " + _toDisplayString(_ctx.isRunning(_ctx.manualAction(step.id, true))
                    ? "Saltando…"
                    : "N/A — saltado"), 1)
                      ], 8, _hoisted_220),
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-success",
                        disabled: _ctx.busy || !_ctx.unlocked(step) || _ctx.isDone(step.id),
                        onClick: ($event: any) => (_ctx.completeManual(step.id))
                      }, [
                        (_ctx.isRunning(_ctx.manualAction(step.id, false)))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_224))
                          : (_openBlock(), _createElementBlock("i", _hoisted_225)),
                        _createTextVNode(" " + _toDisplayString(_ctx.isRunning(_ctx.manualAction(step.id, false))
                    ? "Marcando…"
                    : _ctx.isDone(step.id)
                    ? "Verificado"
                    : "Confirmo que está"), 1)
                      ], 8, _hoisted_223)
                    ]))
                  : (step.kind === 'manual')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                        (step.command)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_226, [
                              _createElementVNode("div", _hoisted_227, [
                                _cache[157] || (_cache[157] = _createElementVNode("label", { class: "form-label small fw-bold mb-0" }, "Comando", -1)),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["badge", _ctx.projectIsProd ? 'bg-danger' : 'bg-info text-dark'])
                                }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["fas", _ctx.projectIsProd ? 'fa-radiation' : 'fa-flask'])
                                  }, null, 2),
                                  _createTextVNode(" <PROJECT> = " + _toDisplayString(_ctx.projectId), 1)
                                ], 2),
                                _cache[158] || (_cache[158] = _createElementVNode("span", { class: "small text-muted" }, " un botón por comando; los comentarios se ven pero no se copian. ", -1)),
                                _createElementVNode("button", {
                                  class: "btn btn-sm btn-outline-secondary py-0 ms-auto",
                                  type: "button",
                                  disabled: _ctx.needsExportStamp(_ctx.wholeCommand(step)),
                                  title: 
                    _ctx.needsExportStamp(_ctx.wholeCommand(step))
                      ? 'Falta el sello del export: pégalo en «Sello del export», en el paso del backup o en la cabecera'
                      : 'Copia el bloque entero tal cual, comentarios incluidos'
                  ,
                                  onClick: ($event: any) => (_ctx.copyText(_ctx.wholeCommand(step), 'all-' + step.id))
                                }, [
                                  _cache[156] || (_cache[156] = _createElementVNode("i", { class: "fas fa-clipboard" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.copiedKey === "all-" + step.id
                      ? "bloque copiado"
                      : "copiar bloque entero"), 1)
                                ], 8, _hoisted_228)
                              ]),
                              (_ctx.needsExportStamp(_ctx.wholeCommand(step)))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_229, [...(_cache[159] || (_cache[159] = [
                                    _createElementVNode("i", { class: "fas fa-circle-exclamation" }, null, -1),
                                    _createElementVNode("strong", null, "Falta el sello del export.", -1),
                                    _createTextVNode(" Este comando lleva la ruta del backup, y el sello lo puso la terminal cuando corriste el export — no lo sabe nadie más. Pégalo en ", -1),
                                    _createElementVNode("strong", null, "«Sello del export»", -1),
                                    _createTextVNode(" —está en el paso del backup, que es donde sale, y en la cabecera— y esta ruta se completa sola. Hasta entonces copiar está desactivado: el texto sigue a la vista y se puede seleccionar, pero no queremos que salga de aquí un import con el marcador puesto. ", -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              (_ctx.pendingPlaceholders(step).length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_230, [
                                    _cache[160] || (_cache[160] = _createElementVNode("i", { class: "fas fa-pen" }, null, -1)),
                                    _cache[161] || (_cache[161] = _createTextVNode(" Sigue habiendo que rellenar a mano: ", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingPlaceholders(step), (ph) => {
                                      return (_openBlock(), _createElementBlock("code", {
                                        key: ph,
                                        class: "me-1 badge bg-light text-dark border pkg-token"
                                      }, _toDisplayString(ph), 1))
                                    }), 128)),
                                    _cache[162] || (_cache[162] = _createTextVNode(" — la consola no inventa esos valores. ", -1))
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.literalOtherProject(step))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_231, [
                                    _cache[163] || (_cache[163] = _createElementVNode("i", { class: "fas fa-triangle-exclamation" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.literalOtherProject(step)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.commandChunks(step))
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.commandChunks(step), (chunk, ix) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: ix,
                                      class: "cmd-chunk"
                                    }, [
                                      (chunk.comments)
                                        ? (_openBlock(), _createElementBlock("pre", _hoisted_232, _toDisplayString(chunk.comments), 1))
                                        : _createCommentVNode("", true),
                                      (chunk.code)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_233, [
                                            _createElementVNode("pre", {
                                              class: _normalizeClass(["command-block flex-grow-1", { 'command-block-prod': _ctx.projectIsProd }])
                                            }, [
                                              _createElementVNode("code", null, _toDisplayString(chunk.code), 1)
                                            ], 2),
                                            _createElementVNode("button", {
                                              class: _normalizeClass(["btn btn-sm cmd-copy", 
                        _ctx.projectIsProd ? 'btn-danger' : 'btn-outline-secondary'
                      ]),
                                              type: "button",
                                              disabled: _ctx.needsExportStamp(chunk.code),
                                              title: 
                        _ctx.needsExportStamp(chunk.code)
                          ? 'Falta el sello del export: pégalo en «Sello del export», en el paso del backup o en la cabecera'
                          : _ctx.projectIsProd
                          ? 'Copiar — APUNTA A PRODUCCIÓN (gtr-academy)'
                          : 'Copiar sólo este comando'
                      ,
                                              onClick: ($event: any) => (_ctx.copyText(chunk.code, step.id + '-' + ix))
                                            }, [
                                              _createElementVNode("i", {
                                                class: _normalizeClass(["fas", 
                          _ctx.copiedKey === step.id + '-' + ix
                            ? 'fa-check'
                            : 'fa-copy'
                        ])
                                              }, null, 2),
                                              _createTextVNode(" " + _toDisplayString(_ctx.copiedKey === step.id + "-" + ix ? "copiado" : "copiar"), 1)
                                            ], 10, _hoisted_234)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (chunk.trailing)
                                        ? (_openBlock(), _createElementBlock("pre", _hoisted_235, _toDisplayString(chunk.trailing), 1))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                    _createElementVNode("pre", {
                                      class: _normalizeClass(["command-block", { 'command-block-prod': _ctx.projectIsProd }])
                                    }, [
                                      _createElementVNode("code", null, _toDisplayString(_ctx.wholeCommand(step)), 1)
                                    ], 2),
                                    _cache[164] || (_cache[164] = _createElementVNode("div", { class: "small text-muted mt-1" }, " Este bloque no se parte en comandos sueltos (hay algo que no se cierra). Se deja entero a propósito: usa «copiar bloque entero». ", -1))
                                  ], 64)),
                              (_ctx.copyError)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_236, [
                                    _cache[165] || (_cache[165] = _createElementVNode("i", { class: "fas fa-circle-exclamation" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.copyError), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_237, [
                          (step.id === _ctx.backupStepId)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_238, [
                                _cache[169] || (_cache[169] = _createElementVNode("label", { class: "form-label small mb-1" }, "Sello del export", -1)),
                                _createElementVNode("div", _hoisted_239, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.exportStamp) = $event)),
                                    class: _normalizeClass(["form-control form-control-sm export-stamp-input", {
                      'is-invalid': !!_ctx.exportStampProblem,
                      'is-valid': !!_ctx.exportStampValue,
                    }]),
                                    placeholder: "pega aquí la ruta o el sello",
                                    title: "Lo que acaba de devolver este export. Vale la ruta entera (gs://…/pre-reset-AAAAMMDD-HHMM) o sólo el sello: de la ruta se saca solo."
                                  }, null, 2), [
                                    [_vModelText, _ctx.exportStamp]
                                  ]),
                                  (_ctx.exportStampValue)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_240, [
                                        _cache[166] || (_cache[166] = _createElementVNode("i", { class: "fas fa-check" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.exportStampValue), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.exportPath)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_241, [
                                      _cache[167] || (_cache[167] = _createTextVNode(" Los imports apuntarán a ", -1)),
                                      _createElementVNode("code", _hoisted_242, _toDisplayString(_ctx.exportPath), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.exportStampProblem)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_243, [
                                      _cache[168] || (_cache[168] = _createElementVNode("i", { class: "fas fa-circle-exclamation" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.exportStampProblem), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_244, [
                            _cache[170] || (_cache[170] = _createElementVNode("label", { class: "form-label small mb-1" }, "¿Cuánto tardó? (min)", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((_ctx.minutes[step.id]) = $event),
                              type: "number",
                              min: "0",
                              class: "form-control form-control-sm",
                              style: {"width":"7rem"}
                            }, null, 8, _hoisted_245), [
                              [
                                _vModelText,
                                _ctx.minutes[step.id],
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_246, [
                            _cache[171] || (_cache[171] = _createElementVNode("label", { class: "form-label small mb-1" }, "Nota", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((_ctx.notes[step.id]) = $event),
                              class: "form-control form-control-sm",
                              placeholder: "opcional"
                            }, null, 8, _hoisted_247), [
                              [_vModelText, _ctx.notes[step.id]]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_248, [
                            _createElementVNode("button", {
                              class: "btn btn-sm btn-outline-secondary",
                              disabled: _ctx.busy || !_ctx.unlocked(step) || _ctx.isDone(step.id),
                              title: "Este paso no aplica en este run. Queda como `skipped`, que desbloquea igual que «hecho» — y el run guarda la diferencia.",
                              onClick: ($event: any) => (_ctx.completeManual(step.id, true))
                            }, [
                              (_ctx.isRunning(_ctx.manualAction(step.id, true)))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_250))
                                : (_openBlock(), _createElementBlock("i", _hoisted_251)),
                              _createTextVNode(" " + _toDisplayString(_ctx.isRunning(_ctx.manualAction(step.id, true))
                      ? "Saltando…"
                      : "N/A — saltado"), 1)
                            ], 8, _hoisted_249)
                          ]),
                          _createElementVNode("div", _hoisted_252, [
                            _createElementVNode("button", {
                              class: "btn btn-sm btn-success",
                              disabled: 
                    _ctx.busy ||
                    !_ctx.unlocked(step) ||
                    _ctx.isDone(step.id) ||
                    !!_ctx.doneBlockedReason(step)
                  ,
                              title: _ctx.doneBlockedReason(step),
                              onClick: ($event: any) => (_ctx.completeManual(step.id))
                            }, [
                              (_ctx.isRunning(_ctx.manualAction(step.id, false)))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_254))
                                : (_openBlock(), _createElementBlock("i", _hoisted_255)),
                              _createTextVNode(" " + _toDisplayString(_ctx.isRunning(_ctx.manualAction(step.id, false))
                      ? "Marcando…"
                      : "Hecho"), 1)
                            ], 8, _hoisted_253)
                          ])
                        ])
                      ], 64))
                    : (step.kind === 'auto')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                          (step.id !== _ctx.cofounderStepId)
                            ? (_openBlock(), _createBlock(_component_StepAuto, {
                                key: 0,
                                step: step,
                                "run-id": _ctx.runId,
                                unlocked: _ctx.unlocked(step),
                                busy: _ctx.busy,
                                "running-dry": _ctx.isRunning(_ctx.autoAction(step.id, true)),
                                "running-run": _ctx.isRunning(_ctx.autoAction(step.id, false)),
                                state: _ctx.stateOf(step.id),
                                onRun: _ctx.runAuto
                              }, null, 8, ["step", "run-id", "unlocked", "busy", "running-dry", "running-run", "state", "onRun"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 12 }, [
                          _createElementVNode("div", _hoisted_256, [
                            _createElementVNode("button", {
                              class: "btn btn-sm btn-outline-primary",
                              disabled: _ctx.busy || !!_ctx.resolveBlocker(step),
                              onClick: ($event: any) => (_ctx.resolve(step.id))
                            }, [
                              (_ctx.isRunning(`resolve:${step.id}`))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_258))
                                : (_openBlock(), _createElementBlock("i", _hoisted_259)),
                              _cache[172] || (_cache[172] = _createTextVNode(" 1. Calcular draft ", -1))
                            ], 8, _hoisted_257),
                            _createElementVNode("button", {
                              class: "btn btn-sm btn-outline-secondary",
                              disabled: _ctx.busy || !_ctx.draftFor(step.id),
                              onClick: ($event: any) => (_ctx.dryApply(step.id))
                            }, [
                              (_ctx.isRunning(`dryApply:${step.id}`))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_261))
                                : (_openBlock(), _createElementBlock("i", _hoisted_262)),
                              _cache[173] || (_cache[173] = _createTextVNode(" 2. Dry-run del apply ", -1))
                            ], 8, _hoisted_260),
                            _createElementVNode("button", {
                              class: "btn btn-sm btn-danger",
                              disabled: _ctx.busy || !_ctx.draftFor(step.id) || !_ctx.approved[step.id],
                              onClick: ($event: any) => (_ctx.apply(step.id))
                            }, [
                              (_ctx.isRunning(`apply:${step.id}`))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_264))
                                : (_openBlock(), _createElementBlock("i", _hoisted_265)),
                              _cache[174] || (_cache[174] = _createTextVNode(" 4. Aplicar ", -1))
                            ], 8, _hoisted_263),
                            _createElementVNode("div", _hoisted_266, [
                              _withDirectives(_createElementVNode("input", {
                                id: 'approve-' + step.id,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.approved[step.id]) = $event),
                                class: "form-check-input mt-0 me-2",
                                type: "checkbox",
                                disabled: !_ctx.draftFor(step.id)
                              }, null, 8, _hoisted_267), [
                                [_vModelCheckbox, _ctx.approved[step.id]]
                              ]),
                              _createElementVNode("label", {
                                class: "form-check-label small",
                                for: 'approve-' + step.id
                              }, " 3. Revisé el árbol y la tabla, y lo apruebo ", 8, _hoisted_268)
                            ])
                          ]),
                          (_ctx.reviewBlockers(step).length)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_269, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reviewBlockers(step), (reason) => {
                                  return (_openBlock(), _createElementBlock("li", { key: reason }, _toDisplayString(reason), 1))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_270)),
                          (_ctx.draftFor(step.id) && step.id === 'build-trees--c')
                            ? (_openBlock(), _createBlock(_component_DraftPreviewTable, {
                                key: 2,
                                draft: _ctx.draftFor(step.id)
                              }, null, 8, ["draft"]))
                            : (_ctx.draftFor(step.id) && step.id === 'build-cmmi--c')
                              ? (_openBlock(), _createBlock(_component_MmiDraftPreview, {
                                  key: 3,
                                  draft: _ctx.draftFor(step.id)
                                }, null, 8, ["draft"]))
                              : _createCommentVNode("", true)
                        ], 64)),
                (
              _ctx.isGateStep(step.id) &&
              (_ctx.gateReportOf(step.id) || _ctx.gateRunning(step.id))
            )
                  ? (_openBlock(), _createBlock(_component_InvariantGate, {
                      key: 13,
                      class: "mt-3",
                      gate: _ctx.gateReportOf(step.id),
                      running: _ctx.gateRunning(step.id),
                      catalog: _ctx.catalogOf(step.id),
                      "ok-note": _ctx.gateOkNote(step.id)
                    }, null, 8, ["gate", "running", "catalog", "ok-note"]))
                  : _createCommentVNode("", true),
                (_ctx.gateIsRed(step))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_271, [
                      _cache[175] || (_cache[175] = _createElementVNode("div", { class: "mb-2" }, [
                        _createElementVNode("i", { class: "fas fa-triangle-exclamation" }),
                        _createElementVNode("strong", null, "Este gate está en ROJO, así que el paso NO cuenta como hecho"),
                        _createTextVNode(" y lo que depende de él queda bloqueado. El camino normal es arreglar lo que lista arriba y volver a pulsarlo: sólo lee, se puede re-correr las veces que haga falta. ")
                      ], -1)),
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-outline-danger",
                        disabled: _ctx.busy || !_ctx.unlocked(step),
                        title: "Marca el paso como hecho SABIENDO que su veredicto es rojo. Queda escrito en el run quién lo hizo y qué falla. NO abre la red: descongelar vuelve a leer el veredicto y sigue negándose.",
                        onClick: ($event: any) => (_ctx.acceptRedGate(step))
                      }, [
                        (_ctx.isRunning(_ctx.acceptRedAction(step.id)))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_273))
                          : (_openBlock(), _createElementBlock("i", _hoisted_274)),
                        _createTextVNode(" " + _toDisplayString(_ctx.isRunning(_ctx.acceptRedAction(step.id))
                  ? "Aceptando…"
                  : "Continuar a pesar del rojo"), 1)
                      ], 8, _hoisted_272),
                      _cache[176] || (_cache[176] = _createElementVNode("span", { class: "ms-2" }, " Deja constancia en el run, con tu nombre y los invariantes que fallan. No descongela: el paso de abrir la red vuelve a leer el veredicto. ", -1))
                    ]))
                  : (_ctx.gateRedAccepted(step))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_275, [
                        _cache[177] || (_cache[177] = _createElementVNode("i", { class: "fas fa-unlock" }, null, -1)),
                        _cache[178] || (_cache[178] = _createTextVNode(" Este paso está marcado como hecho ", -1)),
                        _cache[179] || (_cache[179] = _createElementVNode("strong", null, "con su veredicto en ROJO", -1)),
                        _createTextVNode(", a propósito. " + _toDisplayString(_ctx.stateOf(step.id)?.note), 1)
                      ]))
                    : _createCommentVNode("", true),
                (step.id === 'unfreeze--c')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_276, [
                      _createElementVNode("ol", _hoisted_277, [
                        _createElementVNode("li", {
                          class: _normalizeClass(_ctx.gateGreen ? 'text-success' : 'text-danger')
                        }, [
                          _cache[180] || (_cache[180] = _createTextVNode(" Invariantes en verde (paso 18) ", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(["fas", _ctx.gateGreen ? 'fa-check' : 'fa-xmark'])
                          }, null, 2)
                        ], 2),
                        _createElementVNode("li", null, [
                          _cache[182] || (_cache[182] = _createTextVNode(" Validación humana de los árboles ", -1)),
                          _cache[183] || (_cache[183] = _createElementVNode("strong", null, "con el sistema aún cerrado", -1)),
                          _cache[184] || (_cache[184] = _createTextVNode(" — ", -1)),
                          _createVNode(_component_router_link, {
                            to: { name: 'binary-tree' },
                            target: "_blank"
                          }, {
                            default: _withCtx(() => [...(_cache[181] || (_cache[181] = [
                              _createTextVNode(" abre la Vista de Árbol ", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[185] || (_cache[185] = _createTextVNode(" (usa el flag ", -1)),
                          _cache[186] || (_cache[186] = _createElementVNode("code", null, "useNewTree", -1)),
                          _cache[187] || (_cache[187] = _createTextVNode("). ", -1))
                        ]),
                        _cache[188] || (_cache[188] = _createElementVNode("li", null, "Descongelar de verdad.", -1))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.stepError[step.id])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_278, [
                      _createElementVNode("div", _hoisted_279, [
                        _cache[189] || (_cache[189] = _createElementVNode("i", { class: "fas fa-circle-exclamation" }, null, -1)),
                        _createTextVNode(" Falló el paso " + _toDisplayString(step.label) + " — " + _toDisplayString(step.title), 1)
                      ]),
                      _createElementVNode("div", _hoisted_280, _toDisplayString(_ctx.stepError[step.id]), 1),
                      _cache[190] || (_cache[190] = _createElementVNode("div", { class: "small text-muted mt-1" }, " Lo escribió el backend. Arréglalo donde dice y vuelve a pulsar: el mensaje se borra al empezar el siguiente intento. ", -1))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.lastCall[step.id])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_281, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["alert py-2 mb-1 small", 
                _ctx.lastCall[step.id].dryRun ? 'alert-secondary' : 'alert-success'
              ])
                      }, [
                        _createElementVNode("strong", null, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["fas", _ctx.lastCall[step.id].dryRun ? 'fa-eye' : 'fa-play'])
                          }, null, 2),
                          _createTextVNode(" " + _toDisplayString(_ctx.lastCall[step.id].dryRun
                    ? "DRY-RUN (no escribió nada, y el paso NO avanzó)"
                    : "EJECUCIÓN"), 1)
                        ]),
                        _createTextVNode(" · " + _toDisplayString(_ctx.lastCall[step.id].label) + " · " + _toDisplayString(_ctx.lastCall[step.id].at), 1)
                      ], 2),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultFlags(step.id), (flag) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: flag,
                          class: "alert alert-warning py-2 small mb-1"
                        }, [
                          _cache[191] || (_cache[191] = _createElementVNode("i", { class: "fas fa-triangle-exclamation" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(flag), 1)
                        ]))
                      }), 128)),
                      _createElementVNode("pre", _hoisted_282, [
                        _createElementVNode("code", null, _toDisplayString(_ctx.pretty(_ctx.lastCall[step.id].payload)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.stateOf(step.id)?.result)
                  ? (_openBlock(), _createElementBlock("details", _hoisted_283, [
                      _cache[192] || (_cache[192] = _createElementVNode("summary", { class: "small text-muted" }, "Resultado guardado en el run", -1)),
                      _createElementVNode("pre", _hoisted_284, [
                        _createElementVNode("code", null, _toDisplayString(_ctx.pretty(_ctx.stateOf(step.id)?.result)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.stateOf(step.id)?.note)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_285, _toDisplayString(_ctx.stateOf(step.id)?.note), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_286, [
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-secondary rounded-circle step-collapse-bottom",
                    title: `Cerrar ${step.id}`,
                    "aria-label": `Cerrar el paso ${step.id}`,
                    onClick: ($event: any) => (_ctx.collapseFromFooter(step.id, $event))
                  }, [...(_cache[193] || (_cache[193] = [
                    _createElementVNode("i", {
                      class: "fas fa-chevron-up",
                      "aria-hidden": "true"
                    }, null, -1)
                  ]))], 8, _hoisted_287)
                ])
              ], 512), [
                [_vShow, _ctx.open[step.id]]
              ])
            ], 2))
          }), 128))
        ]))
  ]))
}